/**
 * A function to create a log object for the 'marketingSignUpStartSignUpFlow' event (evid: 100)
 *
 * Event description: Click on one of the 'Get Started' buttons in wixanswers.com's homepage / 'Don't have an account? Sign Up here' on login first step (page 'Enter Your Wix Answers Domain')
 *
 * @param {marketingSignUpStartSignUpFlowParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant of the performing user
 * @property {string} referral_name - referral
 * @property {string} location - The field will be deprecated
 * @property {GUID} session_id - A unique guid for sign up flow
 * @property {Url} referral_url - referral
 * @property {string} permission_level - The field will be deprecated
 * @property {GUID} client_id - Answers client id
 * @property {GUID} user_id - Answers uuid
 * @property {string} locale - Answers language
 * @property {GUID} marketing_id - The field will be deprecated
 * @property {number} campaign_id - The field will be deprecated
 * @return {LogObject<marketingSignUpStartSignUpFlowParams>} LogObject<marketingSignUpStartSignUpFlowParams>
 */
export function marketingSignUpStartSignUpFlow(params) {
    return { evid: 100, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsLinkArticleToATicket' event (evid: 1001)
 *
 * Event description: Linking an article to a ticket.event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsLinkArticleToATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - related ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} attach_method - article attachment method (immediate/paste-link/paste-content)
 * @property {string} origin_name - source name (search/suggestion/create ticket)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} search_term - the string used for searching relevant articles (input search term/ticket subject)
 * @property {GUID} article_id - linked article id
 * @property {string} suggested_article_ids - IDs of all the articles that appeared in the "suggestions component"
 * @property {string} article_name - linked article name
 * @property {string} lang - answers lang
 * @property {string} order_location - article order location in search/suggestions
 * @return {LogObject<appTicketsLinkArticleToATicketParams>} LogObject<appTicketsLinkArticleToATicketParams>
 */
export function appTicketsLinkArticleToATicket(params) {
    return { evid: 1001, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsRemoveRelatedArticleFromATicket' event (evid: 1002)
 *
 * Event description: Remove a related article from a ticket
 *
 * @param {appTicketsRemoveRelatedArticleFromATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - related ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - linked article id
 * @property {string} article_name - linked article name
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsRemoveRelatedArticleFromATicketParams>} LogObject<appTicketsRemoveRelatedArticleFromATicketParams>
 */
export function appTicketsRemoveRelatedArticleFromATicket(params) {
    return { evid: 1002, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsThumbsDownASuggestedArticle' event (evid: 1003)
 *
 * Event description: Voting against a suggested article for a ticket
 *
 * @param {appTicketsThumbsDownASuggestedArticleParams} params - The parameters for this event
 * @property {GUID} ticket_id - related ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} search_term - the string used for searching relevant articles is the ticket subject
 * @property {GUID} article_id - linked article id
 * @property {string} article_name - linked article name
 * @property {string} lang - answers lang
 * @property {string} order_location - article order location in search/suggestions
 * @return {LogObject<appTicketsThumbsDownASuggestedArticleParams>} LogObject<appTicketsThumbsDownASuggestedArticleParams>
 */
export function appTicketsThumbsDownASuggestedArticle(params) {
    return { evid: 1003, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsSearchForATicket' event (evid: 1004)
 *
 * Event description: Search for a ticket in the search line
 *
 * @param {appTicketsSearchForATicketParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} number_of_related_tickets - number of returned tickets
 * @property {string} search_term - the string used to search a ticket
 * @property {string} first_answer - Title of first ticket shown to the user
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsSearchForATicketParams>} LogObject<appTicketsSearchForATicketParams>
 */
export function appTicketsSearchForATicket(params) {
    return { evid: 1004, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsPressButtonCreateTicket' event (evid: 1005)
 *
 * Event description: Press the button to + Create ticket
 *
 * @param {appTicketsPressButtonCreateTicketParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsPressButtonCreateTicketParams>} LogObject<appTicketsPressButtonCreateTicketParams>
 */
export function appTicketsPressButtonCreateTicket(params) {
    return { evid: 1005, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsCreateATicket' event (evid: 1006)
 *
 * Event description: create a ticket with all its details - click "Create ticket" blue button
 *
 * @param {appTicketsCreateATicketParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsCreateATicketParams>} LogObject<appTicketsCreateATicketParams>
 */
export function appTicketsCreateATicket(params) {
    return { evid: 1006, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxClickOnATicket' event (evid: 1007)
 *
 * Event description: Click on a ticket from the list. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxClickOnATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {Ticket list, email, notification list...}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} position - position of the ticket in the page (1,2,3...)
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxClickOnATicketParams>} LogObject<appTicketsOneInboxClickOnATicketParams>
 */
export function appTicketsOneInboxClickOnATicket(params) {
    return { evid: 1007, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxChangeTicketStatus' event (evid: 1008)
 *
 * Event description: Ticket top bar - Status changed (click on button after selecting a new status). event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxChangeTicketStatusParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - status name {pending, closed...}
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {number} status_id - status id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxChangeTicketStatusParams>} LogObject<appTicketsOneInboxChangeTicketStatusParams>
 */
export function appTicketsOneInboxChangeTicketStatus(params) {
    return { evid: 1008, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteATicketClick' event (evid: 1009)
 *
 * Event description: click "delete" option from the bottom bar. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteATicketClickParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - status name
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {number} status_id - status id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxDeleteATicketClickParams>} LogObject<appTicketsOneInboxDeleteATicketClickParams>
 */
export function appTicketsOneInboxDeleteATicketClick(params) {
    return { evid: 1009, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingSignUpClickSignUpWithSso' event (evid: 101)
 *
 * Event description: Click on the "Signup with .." button on the first personal step of sign up flow
 *
 * @param {marketingSignUpClickSignUpWithSsoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {string} sso_type - wix/ google / facebook
 * @property {GUID} client_id - Answers uuid
 * @property {GUID} user_id - answers ID
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpClickSignUpWithSsoParams>} LogObject<marketingSignUpClickSignUpWithSsoParams>
 */
export function marketingSignUpClickSignUpWithSso(params) {
    return { evid: 101, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteATicketConfirm' event (evid: 1010)
 *
 * Event description: Delete a ticket from the action bar confirm - click the red button. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteATicketConfirmParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - status name
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} is_blocked - Did the user check the "block user" check
 * @property {string} permission_level - User's permission level
 * @property {number} status_id - status id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxDeleteATicketConfirmParams>} LogObject<appTicketsOneInboxDeleteATicketConfirmParams>
 */
export function appTicketsOneInboxDeleteATicketConfirm(params) {
    return { evid: 1010, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxAddEmailReplySuccess' event (evid: 1011)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsOneInboxAddEmailReplySuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxAddEmailReplySuccessParams>} LogObject<appTicketsOneInboxAddEmailReplySuccessParams>
 */
export function appTicketsOneInboxAddEmailReplySuccess(params) {
    return { evid: 1011, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsDeleteAReplyClick' event (evid: 1012)
 *
 * Event description: Click Delete a reply from a ticket. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsDeleteAReplyClickParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} content - reply's content
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsDeleteAReplyClickParams>} LogObject<appTicketsDeleteAReplyClickParams>
 */
export function appTicketsDeleteAReplyClick(params) {
    return { evid: 1012, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteAReplyConfirm' event (evid: 1013)
 *
 * Event description: Click "OK" after being asked "Are you sure?". event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteAReplyConfirmParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} content - reply's content
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxDeleteAReplyConfirmParams>} LogObject<appTicketsOneInboxDeleteAReplyConfirmParams>
 */
export function appTicketsOneInboxDeleteAReplyConfirm(params) {
    return { evid: 1013, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteAReplyCancel' event (evid: 1014)
 *
 * Event description: Click "Cancel" after being asked "Are you sure?". event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteAReplyCancelParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} content - reply's content
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxDeleteAReplyCancelParams>} LogObject<appTicketsOneInboxDeleteAReplyCancelParams>
 */
export function appTicketsOneInboxDeleteAReplyCancel(params) {
    return { evid: 1014, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsClickOnAnIcon' event (evid: 1015)
 *
 * Event description: Click on one of the icons in the reply. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsClickOnAnIconParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {team note/reply/create ticket}
 * @property {GUID} reply_id - saved reply id
 * @property {string} icon_type - {emoji, KB, attachment, saved replies...}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsClickOnAnIconParams>} LogObject<appTicketsClickOnAnIconParams>
 */
export function appTicketsClickOnAnIcon(params) {
    return { evid: 1015, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsAttachmentAddedToReply' event (evid: 1016)
 *
 * Event description: Add attachment to reply. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsAttachmentAddedToReplyParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {team note/reply/create ticket}
 * @property {GUID} reply_id - saved reply id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} attachment_type - attachment file type
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsAttachmentAddedToReplyParams>} LogObject<appTicketsAttachmentAddedToReplyParams>
 */
export function appTicketsAttachmentAddedToReply(params) {
    return { evid: 1016, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsEmojiAddedToReply' event (evid: 1017)
 *
 * Event description: Select and click on the emoji itself. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsEmojiAddedToReplyParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {team note/reply/create ticket}
 * @property {GUID} reply_id - saved reply id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} emoji_type - emoji type {smiley, joy...}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsEmojiAddedToReplyParams>} LogObject<appTicketsEmojiAddedToReplyParams>
 */
export function appTicketsEmojiAddedToReply(params) {
    return { evid: 1017, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsSavedReplyAdded' event (evid: 1018)
 *
 * Event description: click "add to reply" after selecting the reply content
 *
 * @param {appTicketsSavedReplyAddedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - Saved reply added either from the icon or by a hashtag
 * @property {string} results_option - {shared, personal}
 * @property {GUID} reply_id - saved reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} content - saved reply's title
 * @property {string} shortcut - name of hashtag that is defined for this saved reply
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsSavedReplyAddedParams>} LogObject<appTicketsSavedReplyAddedParams>
 */
export function appTicketsSavedReplyAdded(params) {
    return { evid: 1018, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsSwitchReplyType' event (evid: 1019)
 *
 * Event description: Team Note - Switch reply type
 *
 * @param {appTicketsSwitchReplyTypeParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - saved reply id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @property {string} switch_to - desired reply mode {team note/reply}
 * @return {LogObject<appTicketsSwitchReplyTypeParams>} LogObject<appTicketsSwitchReplyTypeParams>
 */
export function appTicketsSwitchReplyType(params) {
    return { evid: 1019, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsAddALabelClick' event (evid: 1020)
 *
 * Event description: Click the + button from inside a ticket in order to add a label
 *
 * @param {appTicketsAddALabelClickParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsAddALabelClickParams>} LogObject<appTicketsAddALabelClickParams>
 */
export function appTicketsAddALabelClick(params) {
    return { evid: 1020, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsLabelAddedToTicket' event (evid: 1021)
 *
 * Event description: Click the + button in order to add a label. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsLabelAddedToTicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {ticket filters (include/exclude), ticket top bar}
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} label_name - label name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @property {boolean} is_new_label - was the label just created?
 * @property {GUID} label_id - label id
 * @return {LogObject<appTicketsLabelAddedToTicketParams>} LogObject<appTicketsLabelAddedToTicketParams>
 */
export function appTicketsLabelAddedToTicket(params) {
    return { evid: 1021, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsRemoveLabelFromATicket' event (evid: 1022)
 *
 * Event description: Click a label in order to remove it from the ticket. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsRemoveLabelFromATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {ticket filters (include/exclude), ticket top bar}
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} label_name - label name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @property {GUID} label_id - label id
 * @return {LogObject<appTicketsRemoveLabelFromATicketParams>} LogObject<appTicketsRemoveLabelFromATicketParams>
 */
export function appTicketsRemoveLabelFromATicket(params) {
    return { evid: 1022, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsAddReplyAttempt' event (evid: 1023)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsAddReplyAttemptParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsAddReplyAttemptParams>} LogObject<appTicketsAddReplyAttemptParams>
 */
export function appTicketsAddReplyAttempt(params) {
    return { evid: 1023, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsAddReplyFail' event (evid: 1024)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsAddReplyFailParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} failReason - fail_reason
 * @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsAddReplyFailParams>} LogObject<appTicketsAddReplyFailParams>
 */
export function appTicketsAddReplyFail(params) {
    return { evid: 1024, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsAssignATicket' event (evid: 1025)
 *
 * Event description: Assign a ticket to a Group or to an Agent. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsAssignATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id of the ticket being assigned
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} to_entity_name - name of the entity which the ticket is assigned to{ Group name, for user it will be null} for real time use. ***in order to use history please use the groups table
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user who assigning the ticket
 * @property {string} operator - who made the assignment { User or Macro }
 * @property {GUID} to_entity_id - id of the entity which the ticket is assigned to{ Group ID, User ID}
 * @property {string} to_entity_type - Type of the entity which the ticket is assigned to {Group, Agent}
 * @return {LogObject<appTicketsAssignATicketParams>} LogObject<appTicketsAssignATicketParams>
 */
export function appTicketsAssignATicket(params) {
    return { evid: 1025, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appOneInboxAMemberClientEngagement' event (evid: 1026)
 *
 * Event description: A generic event for member's clicks/engagements related to One Inbox different components: Views Panel, Tickets List, Ticket Item, Ticket Header, Ticket Actions (footer), Reply Box, Info Panel, App header and Bulk Actions
 *
 * @param {appOneInboxAMemberClientEngagementParams} params - The parameters for this event
 * @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with. Examples: (1) Change Ticket Status, (2) Ticket Info, (3) Views, (4) Pin/Unpin menu etc.
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} data - Json of Data related to the member's engagement. Examples: (1) when changing ticket priority it will show priority before and after, ticket ID etc. , (2) when clicking on a ticket it will show ticket ID
 * @property {string} engaged_component - What "component" the member clicked/engaged with. Examples: Views Panel, Tickets list, Ticket Item, reply box etc.
 * @property {GUID} role_id - Answers Role ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} engagement_name - The name of the Engagement
 * @property {string} layout - ticket list page layout (table/side by side/ list)
 * @property {string} lang - Answers language
 * @return {LogObject<appOneInboxAMemberClientEngagementParams>} LogObject<appOneInboxAMemberClientEngagementParams>
 */
export function appOneInboxAMemberClientEngagement(params) {
    return { evid: 1026, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appOneInboxTicketListPageLoadSuccess' event (evid: 1027)
 *
 * Event description: This Event is triggered every time the Ticket List Page is Loaded Successfully in One Inbox.
 * (please remember to create position columns for all existed columns of table layout and let me know their names afterwards and I will add them to the event)
 *
 * @param {appOneInboxTicketListPageLoadSuccessParams} params - The parameters for this event
 * @property {string} table_or_list_sort - If Layout is Table or List - The Type of sort (newest reply, highest priority etc.)
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} layout_type - Ticket List layout type (Split Pane, List or Table)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} ticket_list_width - If Layout is Split Pane  - Active and Inactive ticket list width
 * @property {number} screen_resolution_height - Screen resolution height
 * @property {boolean} is_my_activity - True - if "only my activity" toggle is enabled, False - if not
 * @property {string} ticket_page_area_width - If Layout is Split Pane -  The ticket page area width
 * @property {boolean} is_views_pinned - Is view menu pinned (True or False)
 * @property {number} ticket_subject_position - If Layout is Table what is the position of this column, if layout is table and the column is not presented - 0, if layout is not table - NULL
 * @property {number} screen_resolution_width - Screen resolution width
 * @property {GUID} answers_role_id - Answers Role ID
 * @property {string} active_ticket_list_sort - If Layout is Split Pane - The Type of sort (newest reply, highest priority etc.)
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - View Port width
 * @property {GUID} user_id - Answers user ID of the member loading the page
 * @property {number} first_message_position - If Layout is Table what is the position of this column, if layout is table and the column is not presented - 0, if layout is not table - NULL
 * @property {GUID} view_id - The Ticket List view ID
 * @property {string} pixel_ratio - Device Pixel Ratio
 * @property {boolean} is_active_ticket_list_collapsed - True, False or blank (if If layout is Split Pane)
 * @property {string} active_ticket_list_height - If Layout is Split Pane  - Active ticket list height
 * @property {number} screen_height - View Port height
 * @property {string} inactive_ticket_list_height - If Layout is Split Pane - Inactive ticket list height
 * @property {string} status_filter - For all layouts (if Split pane - Inactive list) - What status filter is being applied (all, open, solved etc.)
 * @property {string} inactive_ticket_list_sort - If Layout is Split Pane - The Type of sort (newest reply, highest priority etc.)
 * @property {string} lang - answers language
 * @property {string} table_column_positions - If Layout is Table - A Json with all the columns appear in the table layout and their positions, if layout is not table - NULL
 * @property {string} ticket_view_filters - A json with all the filters being applied as part of the ticket view
 * @return {LogObject<appOneInboxTicketListPageLoadSuccessParams>} LogObject<appOneInboxTicketListPageLoadSuccessParams>
 */
export function appOneInboxTicketListPageLoadSuccess(params) {
    return { evid: 1027, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appOneInboxTicketPagePageLoadSuccess' event (evid: 1028)
 *
 * Event description: This Event is triggered every time the Ticket page is Loaded Successfully in One Inbox
 *
 * @param {appOneInboxTicketPagePageLoadSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {boolean} is_show_reply_suggestions - True or False - according to reply box settings
 * @property {number} screen_resolution_height - Screen resolution height
 * @property {number} screen_resolution_width - Screen resolution width
 * @property {GUID} answers_role_id - Answers Role ID
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - View Port width
 * @property {boolean} is_add_signature - True or False - according to reply box settings
 * @property {GUID} user_id - Answers user ID of the member loading the page
 * @property {string} pixel_ratio - Device Pixel Ratio
 * @property {boolean} is_set_and_end_action - True or False - according to reply box settings
 * @property {string} ticket_page_width - Ticket page width
 * @property {number} screen_height - View Port height
 * @property {boolean} is_send_and_assign_to_me - True or False - according to reply box settings
 * @property {string} lang - Answers language
 * @return {LogObject<appOneInboxTicketPagePageLoadSuccessParams>} LogObject<appOneInboxTicketPagePageLoadSuccessParams>
 */
export function appOneInboxTicketPagePageLoadSuccess(params) {
    return { evid: 1028, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTicketsTicketSnoozeStart' event (evid: 1029)
 *
 * Event description: A ticket has been snoozed by an Answers member.
 *
 * @param {appTicketsTicketSnoozeStartParams} params - The parameters for this event
 * @property {GUID} ticket_id - The Id of the Ticket being snoozed
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} week_start_day - TBD - The first day of the week according to the snooze settings (Sunday, Monday)
 * @property {string} snooze_type - The type of Snooze time reference used (Later today, Tomorrow, next week, choose Date & Time)
 * @property {boolean} costumer_reply_unsnooze - Should snooze be ended (canceled) if user reply the ticket (True/False)
 * @property {boolean} is_from_bulk - True - if the Snooze triggered as part of bulk Action, False - If not
 * @property {boolean} is_snooze_update - True- if  it is a Snooze update, False - if it is a "New Snooze"
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member updating the snooze
 * @property {boolean} change_status_to_open - Does end of snooze should change ticket status to open (True/False)
 * @property {GUID} macro_id - Phase 2 - If done by Macro - Macro ID, if not - Null
 * @property {string} operator - Phase 2 - Who made the action (Member, Macro, Spotter)
 * @property {boolean} send_notification - True / False - according to snooze settings
 * @property {GUID} scenario_id - Phase 2 - If done by Spotter - Scenario ID, if not - Null
 * @property {GUID} snooze_id - ID of the Snooze
 * @property {DateTime} last_snooze_time - If it is a Snooze Update, what was the last Snooze time before the update
 * @property {DateTime} snooze_time - The Time the ticket was set to be snoozed
 * @return {LogObject<appTicketsTicketSnoozeStartParams>} LogObject<appTicketsTicketSnoozeStartParams>
 */
export function appTicketsTicketSnoozeStart(params) {
    return { evid: 1029, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingClickSubmitSignUpForm' event (evid: 103)
 *
 * Event description: User attempt to submit the sign- up form.
 *
 * @param {marketingClickSubmitSignUpFormParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client ID
 * @property {GUID} user_id - Answers uuid
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingClickSubmitSignUpFormParams>} LogObject<marketingClickSubmitSignUpFormParams>
 */
export function marketingClickSubmitSignUpForm(params) {
    return { evid: 103, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appOneInboxStartActiveSession' event (evid: 1031)
 *
 * Event description: This Event is triggered every time a member is starting an active session by clicking the "Take Ticket"/"Join Active session" button or by start typing in the reply box.
 *
 * @param {appOneInboxStartActiveSessionParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {number} ticket_existed_active_sessions - The number of active sessions the ticket already have
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The Channel of the ticket
 * @property {string} start_session_type - Take Ticket/Join Active session/start typing
 * @property {string} assigned_entity - Second phase - Is the ticket assigned to a Group or Member
 * @property {GUID} answers_role_id - Answers Role ID
 * @property {GUID} client_id - client_id
 * @property {number} member_existed_active_sessions - The number of active sessions the member already have
 * @property {GUID} user_id - Answers user ID of the member loading the page
 * @property {GUID} assigned_entity_id - assigned_entity_id
 * @property {number} ticket_status_type - Second phase - Ticket Status
 * @property {string} lang - Answers language
 * @return {LogObject<appOneInboxStartActiveSessionParams>} LogObject<appOneInboxStartActiveSessionParams>
 */
export function appOneInboxStartActiveSession(params) {
    return { evid: 1031, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpSuccessFirstStep' event (evid: 104)
 *
 * Event description: success on first step of the sign up flow
 *
 * @param {marketingSignUpSignUpSuccessFirstStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client ID
 * @property {GUID} wix_user_id - wix user id
 * @property {GUID} user_id - Answers uuid
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {GUID} wix_client_id - Wix client (Anonymous) ID
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpSignUpSuccessFirstStepParams>} LogObject<marketingSignUpSignUpSuccessFirstStepParams>
 */
export function marketingSignUpSignUpSuccessFirstStep(params) {
    return { evid: 104, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpFailedFirstStep' event (evid: 105)
 *
 * Event description: User's first step of sign up failed
 *
 * @param {marketingSignUpSignUpFailedFirstStepParams} params - The parameters for this event
 * @property {string} errorReason - the reason for the failure
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - answers client id
 * @property {GUID} user_id - Answers uuid
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {string} error_reason - the reason for the failure
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpSignUpFailedFirstStepParams>} LogObject<marketingSignUpSignUpFailedFirstStepParams>
 */
export function marketingSignUpSignUpFailedFirstStep(params) {
    return { evid: 105, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingSignUpSubmitSignUpSecondStep' event (evid: 106)
 *
 * Event description: User sign up attempt on the second step of sign in flow of organization registartion
 *
 * @param {marketingSignUpSubmitSignUpSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client ID
 * @property {GUID} user_id - Answers uuid
 * @property {string} subdomain - Answers URL
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpSubmitSignUpSecondStepParams>} LogObject<marketingSignUpSubmitSignUpSecondStepParams>
 */
export function marketingSignUpSubmitSignUpSecondStep(params) {
    return { evid: 106, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpSuccessSecondStep' event (evid: 107)
 *
 * Event description: Click on the "Log In" button to start l````````````````````````````````````````````````````````````````````````````````````````````````````````````ogin form in wixanswers.com's homepage or from sign up the first step-
 *
 * @param {marketingSignUpSignUpSuccessSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id
 * @property {string} referral_name - referral
 * @property {string} location - DEPRECATE
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - client_id
 * @property {GUID} wix_user_id - wix user id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - Answers URL
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {string} sign_up_method - The method that was used to sign up the user (Email, Wix, Google, etc.)
 * @property {GUID} wix_client_id - Wix client (Anonymous) ID
 * @property {number} campaign_id - DEPRECATE
 * @property {Url} page_url - URL of current page
 * @return {LogObject<marketingSignUpSignUpSuccessSecondStepParams>} LogObject<marketingSignUpSignUpSuccessSecondStepParams>
 */
export function marketingSignUpSignUpSuccessSecondStep(params) {
    return { evid: 107, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpFailedSecondStep' event (evid: 108)
 *
 * Event description: User attempt to submit second sign up flow - add organization and URL
 *
 * @param {marketingSignUpSignUpFailedSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client ID
 * @property {GUID} user_id - Answers uuid
 * @property {string} subdomain - Answers URL
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {string} error_reason - failure reason
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpSignUpFailedSecondStepParams>} LogObject<marketingSignUpSignUpFailedSecondStepParams>
 */
export function marketingSignUpSignUpFailedSecondStep(params) {
    return { evid: 108, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingLogInSubmitPreLoginRedirectToAnswersUrl' event (evid: 109)
 *
 * Event description: User attempts to continue with his login first step - recognize tenant URL
 *
 * @param {marketingLogInSubmitPreLoginRedirectToAnswersUrlParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client id
 * @property {GUID} user_id - Answers uuid
 * @property {string} subdomain - Answers URL
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingLogInSubmitPreLoginRedirectToAnswersUrlParams>} LogObject<marketingLogInSubmitPreLoginRedirectToAnswersUrlParams>
 */
export function marketingLogInSubmitPreLoginRedirectToAnswersUrl(params) {
    return { evid: 109, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingLogInPreLoginRedirectSuccess' event (evid: 110)
 *
 * Event description: User's Pre- login success - redirect tenant URL
 *
 * @param {marketingLogInPreLoginRedirectSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - A unique guid for login flow
 * @property {Url} referral_url - referral
 * @property {string} permission_level - The field will be deprtecated
 * @property {GUID} client_id
 * @property {GUID} user_id
 * @property {string} subdomain - Answers tenant URL
 * @property {string} locale - Answers language
 * @property {GUID} marketing_id - The field will be deprecated
 * @property {number} campaign_id - The field will be deprtecated
 * @return {LogObject<marketingLogInPreLoginRedirectSuccessParams>} LogObject<marketingLogInPreLoginRedirectSuccessParams>
 */
export function marketingLogInPreLoginRedirectSuccess(params) {
    return { evid: 110, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticleSaveAttempt' event (evid: 1100)
 *
 * Event description: start save process after clicking "Save"
 *
 * @param {appKbEditArticleSaveAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {number} ts - amount of time (milliseconds) since "save" button clicked
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @return {LogObject<appKbEditArticleSaveAttemptParams>} LogObject<appKbEditArticleSaveAttemptParams>
 */
export function appKbEditArticleSaveAttempt(params) {
    return { evid: 1100, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticleSaveSuccess' event (evid: 1101)
 *
 * Event description: Finish save process
 *
 * @param {appKbEditArticleSaveSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {number} ts - amount of time (milliseconds) since save process started
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @return {LogObject<appKbEditArticleSaveSuccessParams>} LogObject<appKbEditArticleSaveSuccessParams>
 */
export function appKbEditArticleSaveSuccess(params) {
    return { evid: 1101, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticleDelete' event (evid: 1102)
 *
 * Event description: Click "Delete" from the top bar
 *
 * @param {appKbEditArticleDeleteParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticleDeleteParams>} LogObject<appKbEditArticleDeleteParams>
 */
export function appKbEditArticleDelete(params) {
    return { evid: 1102, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticleDeleteConfirm' event (evid: 1103)
 *
 * Event description: Click "Delete" after "Are you sure?" massage
 *
 * @param {appKbEditArticleDeleteConfirmParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticleDeleteConfirmParams>} LogObject<appKbEditArticleDeleteConfirmParams>
 */
export function appKbEditArticleDeleteConfirm(params) {
    return { evid: 1103, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticlePublish' event (evid: 1104)
 *
 * Event description: Click "Publish" button
 *
 * @param {appKbEditArticlePublishParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticlePublishParams>} LogObject<appKbEditArticlePublishParams>
 */
export function appKbEditArticlePublish(params) {
    return { evid: 1104, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticlePublishConfirm' event (evid: 1105)
 *
 * Event description: Click "Publish my article now" after being asked:
 * "Ready to publish your article?"
 *
 * @param {appKbEditArticlePublishConfirmParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticlePublishConfirmParams>} LogObject<appKbEditArticlePublishConfirmParams>
 */
export function appKbEditArticlePublishConfirm(params) {
    return { evid: 1105, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticleUnpublish' event (evid: 1106)
 *
 * Event description: Click "Unpublish article" from the top bar
 *
 * @param {appKbEditArticleUnpublishParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticleUnpublishParams>} LogObject<appKbEditArticleUnpublishParams>
 */
export function appKbEditArticleUnpublish(params) {
    return { evid: 1106, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticleAssignCategory' event (evid: 1107)
 *
 * Event description: Choose a category for an article
 *
 * @param {appKbEditArticleAssignCategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article/categories page}
 * @property {GUID} orig_parent_id - current category/subcategory of an article (null if new)
 * @property {string} permission_level - User's permission level
 * @property {string} category_name - selected category name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} dest_parent_id - selected category/subcategory
 * @property {GUID} article_id - relevant article id
 * @property {GUID} category_id - selected category id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @return {LogObject<appKbEditArticleAssignCategoryParams>} LogObject<appKbEditArticleAssignCategoryParams>
 */
export function appKbEditArticleAssignCategory(params) {
    return { evid: 1107, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbArticlesListSearch' event (evid: 1108)
 *
 * Event description: When the user searches for an article
 *
 * @param {appKbArticlesListSearchParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} search_term - What the user typed
 * @property {string} first_answer - The first article shown to the user (on the left side) - article id
 * @property {string} lang - answers language
 * @property {number} number_of_related_articles - number of returned articles in answer
 * @return {LogObject<appKbArticlesListSearchParams>} LogObject<appKbArticlesListSearchParams>
 */
export function appKbArticlesListSearch(params) {
    return { evid: 1108, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbArticlesListCreateArticle' event (evid: 1109)
 *
 * Event description: Click on the button to "Create new article"
 *
 * @param {appKbArticlesListCreateArticleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {articles list, categories screen}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - article_id
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category/subcategory id
 * @return {LogObject<appKbArticlesListCreateArticleParams>} LogObject<appKbArticlesListCreateArticleParams>
 */
export function appKbArticlesListCreateArticle(params) {
    return { evid: 1109, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingLogInPreLoginRedirectFailed' event (evid: 111)
 *
 * Event description: User's Pre- login - redirect tenant URL failed
 *
 * @param {marketingLogInPreLoginRedirectFailedParams} params - The parameters for this event
 * @property {string} errorReason - The failed reason
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - A unique guid for login flow
 * @property {Url} referral_url - referral
 * @property {string} permission_level - the field will be deprecated
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - The sub-domain entered in the form
 * @property {string} locale - Answers language
 * @property {GUID} marketing_id - The filed will be deprecated
 * @property {string} error_reason - The failed reason
 * @property {number} campaign_id - The filed will be deprecated
 * @property {Url} page_url - current page
 * @return {LogObject<marketingLogInPreLoginRedirectFailedParams>} LogObject<marketingLogInPreLoginRedirectFailedParams>
 */
export function marketingLogInPreLoginRedirectFailed(params) {
    return { evid: 111, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbArticlesListSelectArticle' event (evid: 1110)
 *
 * Event description: Click on an article from the screen
 *
 * @param {appKbArticlesListSelectArticleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @return {LogObject<appKbArticlesListSelectArticleParams>} LogObject<appKbArticlesListSelectArticleParams>
 */
export function appKbArticlesListSelectArticle(params) {
    return { evid: 1110, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbCategoriesAddCategoryStart' event (evid: 1111)
 *
 * Event description: Click on the button "+ Add category"
 *
 * @param {appKbCategoriesAddCategoryStartParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {side bar/main screen}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - If category - null, if subcategory - category's id
 * @return {LogObject<appKbCategoriesAddCategoryStartParams>} LogObject<appKbCategoriesAddCategoryStartParams>
 */
export function appKbCategoriesAddCategoryStart(params) {
    return { evid: 1111, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbCategoriesAddCategoryComplete' event (evid: 1112)
 *
 * Event description: Create the category after inserting the name
 *
 * @param {appKbCategoriesAddCategoryCompleteParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {side bar/main screen}
 * @property {string} permission_level - User's permission level
 * @property {string} category_name - User's entered value for category
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} category_id - category_id
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - If category - null, if subcategory - category's id
 * @return {LogObject<appKbCategoriesAddCategoryCompleteParams>} LogObject<appKbCategoriesAddCategoryCompleteParams>
 */
export function appKbCategoriesAddCategoryComplete(params) {
    return { evid: 1112, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbCategoriesAddCategoryCancel' event (evid: 1113)
 *
 * Event description: Create category --> click cancel
 *
 * @param {appKbCategoriesAddCategoryCancelParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {side bar/main screen}
 * @property {string} permission_level - User's permission level
 * @property {string} category_name - User's entered value for category (can be null)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} category_id - category_id
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - If category - null, if subcategory - category's id
 * @return {LogObject<appKbCategoriesAddCategoryCancelParams>} LogObject<appKbCategoriesAddCategoryCancelParams>
 */
export function appKbCategoriesAddCategoryCancel(params) {
    return { evid: 1113, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbCategoriesDeleteCategory' event (evid: 1114)
 *
 * Event description: Click Delete category from the category menu
 *
 * @param {appKbCategoriesDeleteCategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {side bar/main screen}
 * @property {string} permission_level - User's permission level
 * @property {string} category_name - User's entered value for category
 * @property {GUID} client_id - client_id
 * @property {boolean} is_complete - if no articles inside - this will be "1". else "0" (an error will pop-up)
 * @property {GUID} user_id - uuid
 * @property {GUID} category_id - Category ID
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - If category - null, if subcategory - category's id
 * @return {LogObject<appKbCategoriesDeleteCategoryParams>} LogObject<appKbCategoriesDeleteCategoryParams>
 */
export function appKbCategoriesDeleteCategory(params) {
    return { evid: 1114, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbEditArticlePublishSuccess' event (evid: 1121)
 *
 * Event description: Successfully publishing an article
 *
 * @param {appKbEditArticlePublishSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {number} ts - amount of time (milliseconds) since save process started
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticlePublishSuccessParams>} LogObject<appKbEditArticlePublishSuccessParams>
 */
export function appKbEditArticlePublishSuccess(params) {
    return { evid: 1121, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbMoveAssignSubcategory' event (evid: 1122)
 *
 * Event description: Assign a subcategory to a different category or make it its own category
 *
 * @param {appKbMoveAssignSubcategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} method - {menu, drag, api...}
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} orig_parent_id - current category/subcategory
 * @property {string} permission_level - User's permission level
 * @property {number} ts - amount of time (milliseconds) since save process started
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} dest_parent_id - selected category/subcategory. if null than it is now a category
 * @property {string} lang - answers language
 * @return {LogObject<appKbMoveAssignSubcategoryParams>} LogObject<appKbMoveAssignSubcategoryParams>
 */
export function appKbMoveAssignSubcategory(params) {
    return { evid: 1122, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbRenameCategorySubcategory' event (evid: 1123)
 *
 * Event description: Rename a category or a subcategory
 *
 * @param {appKbRenameCategorySubcategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - only relevant for subcategories {side menu, main menu}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbRenameCategorySubcategoryParams>} LogObject<appKbRenameCategorySubcategoryParams>
 */
export function appKbRenameCategorySubcategory(params) {
    return { evid: 1123, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appKbChangeCategorySIcon' event (evid: 1124)
 *
 * Event description: Change the category's icon for display
 *
 * @param {appKbChangeCategorySIconParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers language
 * @property {string} action - {Remove,Upload,Stock}
 * @return {LogObject<appKbChangeCategorySIconParams>} LogObject<appKbChangeCategorySIconParams>
 */
export function appKbChangeCategorySIcon(params) {
    return { evid: 1124, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingPageView' event (evid: 113)
 *
 * Event description: Viewing a page in Answers Marketing Site.
 *
 * @param {marketingPageViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} utm_source - Campaign Source (utm_source component in the url)
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - A unique guid for sign up flow
 * @property {Url} referral_url - referral
 * @property {string} permission_level - Level of permission of the performing user
 * @property {GUID} client_id - Answers Client ID
 * @property {GUID} wix_user_id - Wix User ID
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers language
 * @property {GUID} marketing_id - The field will be deprecated
 * @property {string} utm_campaign - Campaign Name (utm_campaign component in the url)
 * @property {GUID} wix_client_id - Wix Client (Anonymous) ID
 * @property {number} campaign_id - The field will be deprecated
 * @property {Url} page_url - URL of the current page
 * @return {LogObject<marketingPageViewParams>} LogObject<marketingPageViewParams>
 */
export function marketingPageView(params) {
    return { evid: 113, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingLogInUserLoginAttempt' event (evid: 114)
 *
 * Event description: User attempt to sign in with mail or other login types on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInUserLoginAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers uuid
 * @property {GUID} user_id - answers ID
 * @property {string} subdomain - answers subdomain
 * @property {Url} page_url - current page
 * @property {string} login_type - wix/ google / facebook/emial
 * @return {LogObject<marketingLogInUserLoginAttemptParams>} LogObject<marketingLogInUserLoginAttemptParams>
 */
export function marketingLogInUserLoginAttempt(params) {
    return { evid: 114, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingLogInSuccessUserLogin' event (evid: 115)
 *
 * Event description: User succeeds to sign in with mail or another login type on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInSuccessUserLoginParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {boolean} is_agent - is account agent
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers uuid
 * @property {GUID} user_id - answers ID
 * @property {string} subdomain - answers subdomian
 * @property {Url} page_url - current page
 * @property {string} login_type - wix/ google / facebook/ email
 * @return {LogObject<marketingLogInSuccessUserLoginParams>} LogObject<marketingLogInSuccessUserLoginParams>
 */
export function marketingLogInSuccessUserLogin(params) {
    return { evid: 115, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingLogInFailedUserLogin' event (evid: 116)
 *
 * Event description: User failed to sign in with mail or other login types on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInFailedUserLoginParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers uuid
 * @property {GUID} user_id - answers ID
 * @property {string} subdomain - answers subdomain
 * @property {string} error_reason - failed reason
 * @property {Url} page_url - current page
 * @property {string} login_type - wix/ google / facebook/ emial
 * @return {LogObject<marketingLogInFailedUserLoginParams>} LogObject<marketingLogInFailedUserLoginParams>
 */
export function marketingLogInFailedUserLogin(params) {
    return { evid: 116, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetWidgetLoaded' event (evid: 117)
 *
 * Event description: The widget is loaded and the user can see the 'Request Demo' widget.
 *
 * @param {marketingRequestDemoWidgetWidgetLoadedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - current page
 * @return {LogObject<marketingRequestDemoWidgetWidgetLoadedParams>} LogObject<marketingRequestDemoWidgetWidgetLoadedParams>
 */
export function marketingRequestDemoWidgetWidgetLoaded(params) {
    return { evid: 117, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetOpenTheWidget' event (evid: 118)
 *
 * Event description: The user open the 'Request Demo' widget.
 *
 * @param {marketingRequestDemoWidgetOpenTheWidgetParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - current page
 * @return {LogObject<marketingRequestDemoWidgetOpenTheWidgetParams>} LogObject<marketingRequestDemoWidgetOpenTheWidgetParams>
 */
export function marketingRequestDemoWidgetOpenTheWidget(params) {
    return { evid: 118, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetSubmitRequestDemo' event (evid: 119)
 *
 * Event description: The user fill all the inputs and submit the request to schedule a demo.
 *
 * @param {marketingRequestDemoWidgetSubmitRequestDemoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - current page
 * @return {LogObject<marketingRequestDemoWidgetSubmitRequestDemoParams>} LogObject<marketingRequestDemoWidgetSubmitRequestDemoParams>
 */
export function marketingRequestDemoWidgetSubmitRequestDemo(params) {
    return { evid: 119, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingWatchAVideoPressOnButton' event (evid: 120)
 *
 * Event description: The user Click on "Watch a video" (a button on the first fold which will link to our YT video)
 *
 * @param {marketingWatchAVideoPressOnButtonParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - Answers user id
 * @property {string} page_url - current page
 * @return {LogObject<marketingWatchAVideoPressOnButtonParams>} LogObject<marketingWatchAVideoPressOnButtonParams>
 */
export function marketingWatchAVideoPressOnButton(params) {
    return { evid: 120, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTeamTeamMemberInvitationSentButtonClick' event (evid: 1203)
 *
 * Event description: Click on the "send" button after adding group members
 *
 * @param {appTeamTeamMemberInvitationSentButtonClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {number} count_admins - count admins added
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} count_agents - count agents added
 * @property {string} lang - answers lang
 * @return {LogObject<appTeamTeamMemberInvitationSentButtonClickParams>} LogObject<appTeamTeamMemberInvitationSentButtonClickParams>
 */
export function appTeamTeamMemberInvitationSentButtonClick(params) {
    return { evid: 1203, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTeamCreateANewGroupClick' event (evid: 1205)
 *
 * Event description: Clicking the "Create Team" button after inserting group name
 *
 * @param {appTeamCreateANewGroupClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group name
 * @property {string} lang - answers lang
 * @return {LogObject<appTeamCreateANewGroupClickParams>} LogObject<appTeamCreateANewGroupClickParams>
 */
export function appTeamCreateANewGroupClick(params) {
    return { evid: 1205, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTeamAddNewGroupMember' event (evid: 1206)
 *
 * Event description: Selecting a group member after clicking the "+ New Team member" button
 *
 * @param {appTeamAddNewGroupMemberParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {Edit group/New group}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group name
 * @property {string} member_name - member name
 * @property {string} lang - answers lang
 * @property {GUID} member_uuid - member uuid
 * @return {LogObject<appTeamAddNewGroupMemberParams>} LogObject<appTeamAddNewGroupMemberParams>
 */
export function appTeamAddNewGroupMember(params) {
    return { evid: 1206, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appTeamAddMembersToGroupClick' event (evid: 1207)
 *
 * Event description: Click on the button "Add members to Group" (blue button or from empty group state)
 *
 * @param {appTeamAddMembersToGroupClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group id
 * @property {number} current_members_count - How many people currently in goup
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group name
 * @property {string} lang - answers lang
 * @return {LogObject<appTeamAddMembersToGroupClickParams>} LogObject<appTeamAddMembersToGroupClickParams>
 */
export function appTeamAddMembersToGroupClick(params) {
    return { evid: 1207, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingLearnMorePressOnButton' event (evid: 121)
 *
 * Event description: The user Click on "Learn more" (a button which will be added below each Product on the home page, linking to the product's specific page)
 *
 * @param {marketingLearnMorePressOnButtonParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} section_name - section name
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - Answers user id
 * @property {string} page_url - current page
 * @return {LogObject<marketingLearnMorePressOnButtonParams>} LogObject<marketingLearnMorePressOnButtonParams>
 */
export function marketingLearnMorePressOnButton(params) {
    return { evid: 121, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoFormSubmitRequestDemo' event (evid: 122)
 *
 * Event description: The user fill all the inputs and submit the request to schedule a demo.
 *
 * @param {marketingRequestDemoFormSubmitRequestDemoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - user id
 * @property {string} page_url - current page
 * @return {LogObject<marketingRequestDemoFormSubmitRequestDemoParams>} LogObject<marketingRequestDemoFormSubmitRequestDemoParams>
 */
export function marketingRequestDemoFormSubmitRequestDemo(params) {
    return { evid: 122, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingCampaignView' event (evid: 124)
 *
 * Event description: The user view a campaign page.
 *
 * @param {marketingCampaignViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} campaign_name - campaign_name
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - user_id
 * @property {GUID} campaign_id - campaign_id
 * @property {string} page_url - current page
 * @return {LogObject<marketingCampaignViewParams>} LogObject<marketingCampaignViewParams>
 */
export function marketingCampaignView(params) {
    return { evid: 124, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingCampaignPageSubmitCampaignForm' event (evid: 125)
 *
 * Event description: The user submit the campaign form and send his details.
 *
 * @param {marketingCampaignPageSubmitCampaignFormParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} campaign_name - campaign_name
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - user_id
 * @property {GUID} campaign_id - campaign_id
 * @property {string} page_url - current page
 * @return {LogObject<marketingCampaignPageSubmitCampaignFormParams>} LogObject<marketingCampaignPageSubmitCampaignFormParams>
 */
export function marketingCampaignPageSubmitCampaignForm(params) {
    return { evid: 125, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'marketingPageViewOnEditorMarketingPage' event (evid: 126)
 *
 * Event description: The user view an Answers page in editor marketing page.
 *
 * @param {marketingPageViewOnEditorMarketingPageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - user_id
 * @property {string} page_name - page name
 * @property {string} page_url - current page
 * @return {LogObject<marketingPageViewOnEditorMarketingPageParams>} LogObject<marketingPageViewOnEditorMarketingPageParams>
 */
export function marketingPageViewOnEditorMarketingPage(params) {
    return { evid: 126, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiDashboardLoadStart' event (evid: 1320)
 *
 * Event description: This event is fired when a dashboard has begun loading, when its tiles will start loading and querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiDashboardLoadStartParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} dashboard_filters - Applied filters on that dashboard run
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Performing User ID
 * @property {string} looker_dashboard_id - Looker Dashboard ID
 * @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 * @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 * @property {string} dashboard_title - Looker Dashboard Title
 * @return {LogObject<appInsightsAdvancedReportsWasabiDashboardLoadStartParams>} LogObject<appInsightsAdvancedReportsWasabiDashboardLoadStartParams>
 */
export function appInsightsAdvancedReportsWasabiDashboardLoadStart(params) {
    return { evid: 1320, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiDashboardLoadComplete' event (evid: 1321)
 *
 * Event description: This event is fired when a dashboard has finished running and all tiles have finished loading and querying. This event is fired whether or not all tiles load successfully.
 *
 * @param {appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - Indicates whether the dashboard and its elements have successfully run, failed, or stopped before finished running
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} dashboard_filters - Applied filters on that dashboard run
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Performing User ID
 * @property {string} looker_dashboard_id - Looker Dashboard ID
 * @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 * @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 * @property {string} dashboard_title - Looker Dashboard Title
 * @return {LogObject<appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams>} LogObject<appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams>
 */
export function appInsightsAdvancedReportsWasabiDashboardLoadComplete(params) {
    return { evid: 1321, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiTileLoadStart' event (evid: 1322)
 *
 * Event description: This event is fired when a tile in a dashboard starts loading or querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiTileLoadStartParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} dashboard_filters - Applied filters on that dashboard run
 * @property {string} tile_listen - The global dashboard filters this tile is listening for
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Performing User ID
 * @property {string} looker_dashboard_id - Looker Dashboard ID
 * @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 * @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 * @property {string} tile_title - The tile title, as shown at the top of the tile
 * @property {string} dashboard_title - Looker Dashboard Title
 * @return {LogObject<appInsightsAdvancedReportsWasabiTileLoadStartParams>} LogObject<appInsightsAdvancedReportsWasabiTileLoadStartParams>
 */
export function appInsightsAdvancedReportsWasabiTileLoadStart(params) {
    return { evid: 1322, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiTileLoadComplete' event (evid: 1323)
 *
 * Event description: This event is fired when a tile in a dashboard starts loading or querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiTileLoadCompleteParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - Whether the tile query completed successfully. Possible values are "complete" or "error"
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} dashboard_filters - Applied filters on that dashboard run
 * @property {string} tile_listen - The global dashboard filters this tile is listening for
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Performing User ID
 * @property {string} looker_dashboard_id - Looker Dashboard ID
 * @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 * @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 * @property {string} tile_title - The tile title, as shown at the top of the tile
 * @property {string} dashboard_title - Looker Dashboard Title
 * @return {LogObject<appInsightsAdvancedReportsWasabiTileLoadCompleteParams>} LogObject<appInsightsAdvancedReportsWasabiTileLoadCompleteParams>
 */
export function appInsightsAdvancedReportsWasabiTileLoadComplete(params) {
    return { evid: 1323, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsClickOn3Dots' event (evid: 1330)
 *
 * Event description: User Click on 3 dots (more option per report)
 * after selecting an action - View / Duplicate / Delete
 *
 * @param {appWasabiAdvancedReportsClickOn3DotsParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant_id
 * @property {string} reportName - report name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} selectedValue - selected_value
 * @return {LogObject<appWasabiAdvancedReportsClickOn3DotsParams>} LogObject<appWasabiAdvancedReportsClickOn3DotsParams>
 */
export function appWasabiAdvancedReportsClickOn3Dots(params) {
    return { evid: 1330, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsCreateNewReport' event (evid: 1331)
 *
 * Event description: User Created new report - 2 options: Reports view / duplicate
 * after clicking on 'Create Report'
 *
 * @param {appWasabiAdvancedReportsCreateNewReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} source_component - source
 * @property {GUID} tenant_id - answers tenant_id
 * @property {string} reportName - report name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @return {LogObject<appWasabiAdvancedReportsCreateNewReportParams>} LogObject<appWasabiAdvancedReportsCreateNewReportParams>
 */
export function appWasabiAdvancedReportsCreateNewReport(params) {
    return { evid: 1331, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsDeleteReport' event (evid: 1332)
 *
 * Event description: User deleted an existing report (non standard report)
 * after clicking on 'Yes, Delete'
 *
 * @param {appWasabiAdvancedReportsDeleteReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant_id
 * @property {string} reportName - report_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appWasabiAdvancedReportsDeleteReportParams>} LogObject<appWasabiAdvancedReportsDeleteReportParams>
 */
export function appWasabiAdvancedReportsDeleteReport(params) {
    return { evid: 1332, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsChangeAttempt' event (evid: 1450)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} changeType - {delete/create/update}
 * @property {GUID} user_id - user_id
 * @property {string} source_name - hc-1 / hc-2
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {string} change_content - json with all the changed information
 * @property {Url} page_url - page_url
 * @return {LogObject<appSettingsChangeAttemptParams>} LogObject<appSettingsChangeAttemptParams>
 */
export function appSettingsChangeAttempt(params) {
    return { evid: 1450, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsChangeSuccess' event (evid: 1451)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} changeType - {delete/create/update}
 * @property {GUID} user_id - user_id
 * @property {string} source_name - hc-1 / hc-2
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {string} change_content - json with all the changed information
 * @property {Url} page_url - page_url
 * @return {LogObject<appSettingsChangeSuccessParams>} LogObject<appSettingsChangeSuccessParams>
 */
export function appSettingsChangeSuccess(params) {
    return { evid: 1451, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsChangeFail' event (evid: 1452)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} errorReason - Reason for fail
 * @property {GUID} client_id - client_id
 * @property {string} changeType - {delete/create/update}
 * @property {GUID} user_id - user_id
 * @property {string} source_name - hc-1 / hc-2
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {string} change_content - json with all the changed information
 * @property {Url} page_url - page_url
 * @return {LogObject<appSettingsChangeFailParams>} LogObject<appSettingsChangeFailParams>
 */
export function appSettingsChangeFail(params) {
    return { evid: 1452, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsAgentClickRolesInTheSettingsMenu' event (evid: 1453)
 *
 * Event description: An agent click "roles" in the settings menu of Answers App
 *
 * @param {appSettingsAgentClickRolesInTheSettingsMenuParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @return {LogObject<appSettingsAgentClickRolesInTheSettingsMenuParams>} LogObject<appSettingsAgentClickRolesInTheSettingsMenuParams>
 */
export function appSettingsAgentClickRolesInTheSettingsMenu(params) {
    return { evid: 1453, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsRolesAgentClickAddCustomRole' event (evid: 1454)
 *
 * Event description: An agent clicks "Add custom role" inside "roles" section of Answers Settings
 *
 * @param {appSettingsRolesAgentClickAddCustomRoleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @return {LogObject<appSettingsRolesAgentClickAddCustomRoleParams>} LogObject<appSettingsRolesAgentClickAddCustomRoleParams>
 */
export function appSettingsRolesAgentClickAddCustomRole(params) {
    return { evid: 1454, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsRolesAgentClickEditRole' event (evid: 1455)
 *
 * Event description: An agent click "Edit" in the right corner menu (3 dots) in the roles section within Answers Settings.
 *
 * @param {appSettingsRolesAgentClickEditRoleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} role_id - The Role ID of the role being "clicked"
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} role_name - The Role Name of the role being "clicked"
 * @return {LogObject<appSettingsRolesAgentClickEditRoleParams>} LogObject<appSettingsRolesAgentClickEditRoleParams>
 */
export function appSettingsRolesAgentClickEditRole(params) {
    return { evid: 1455, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsBillingClickUpdatePaymentMethodModalLink' event (evid: 1459)
 *
 * Event description: Member clicks on the Update Payment Method link in the upper right corner of the Billing Page
 *
 * @param {appSettingsBillingClickUpdatePaymentMethodModalLinkParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingClickUpdatePaymentMethodModalLinkParams>} LogObject<appSettingsBillingClickUpdatePaymentMethodModalLinkParams>
 */
export function appSettingsBillingClickUpdatePaymentMethodModalLink(params) {
    return { evid: 1459, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodAttempt' event (evid: 1460)
 *
 * Event description: Update Payment Method Attempt
 *
 * @param {appSettingsBillingUpdatePaymentMethodAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodAttemptParams>} LogObject<appSettingsBillingUpdatePaymentMethodAttemptParams>
 */
export function appSettingsBillingUpdatePaymentMethodAttempt(params) {
    return { evid: 1460, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodSuccess' event (evid: 1461)
 *
 * Event description: App (Settings) - Billing -  Update Payment Method Success.
 *
 * @param {appSettingsBillingUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodSuccessParams>} LogObject<appSettingsBillingUpdatePaymentMethodSuccessParams>
 */
export function appSettingsBillingUpdatePaymentMethodSuccess(params) {
    return { evid: 1461, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodFail' event (evid: 1462)
 *
 * Event description: App (Settings) - Billing -  Update Payment Method Fail.
 *
 * @param {appSettingsBillingUpdatePaymentMethodFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Reason of failure
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodFailParams>} LogObject<appSettingsBillingUpdatePaymentMethodFailParams>
 */
export function appSettingsBillingUpdatePaymentMethodFail(params) {
    return { evid: 1462, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodModalPreviewRenderFail' event (evid: 1463)
 *
 * Event description: Update payment method modal preview fails to render
 *
 * @param {appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams>} LogObject<appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams>
 */
export function appSettingsBillingUpdatePaymentMethodModalPreviewRenderFail(params) {
    return { evid: 1463, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsBillingPaymentMethodModalUseADifferentCardClick' event (evid: 1464)
 *
 * Event description: App (Settings) - Billing - Payment Method Modal - Use A Different Card Click.
 *
 * @param {appSettingsBillingPaymentMethodModalUseADifferentCardClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {boolean} is_checked - True if checkbox is checked, False if it is un-checked
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingPaymentMethodModalUseADifferentCardClickParams>} LogObject<appSettingsBillingPaymentMethodModalUseADifferentCardClickParams>
 */
export function appSettingsBillingPaymentMethodModalUseADifferentCardClick(params) {
    return { evid: 1464, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appSettingsBillingDownloadInvoiceFile' event (evid: 1465)
 *
 * Event description: Download Invoice file CTA in the invoice history list
 *
 * @param {appSettingsBillingDownloadInvoiceFileParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {number} invoice_amount - Invoice Amount
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @property {DateTime} invoice_date - Invoice Date
 * @return {LogObject<appSettingsBillingDownloadInvoiceFileParams>} LogObject<appSettingsBillingDownloadInvoiceFileParams>
 */
export function appSettingsBillingDownloadInvoiceFile(params) {
    return { evid: 1465, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserOpenedPp' event (evid: 1811)
 *
 * Event description: Answers PP - lightbox appears successfully.
 * First step - User select team size
 * Second Step -  User choose a plan and product.
 * Third step - User select subscription type.
 *
 * @param {appPremiumPackagePickerUserOpenedPpParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - upgrade origin component
 * @return {LogObject<appPremiumPackagePickerUserOpenedPpParams>} LogObject<appPremiumPackagePickerUserOpenedPpParams>
 */
export function appPremiumPackagePickerUserOpenedPp(params) {
    return { evid: 1811, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserClosedPpLightBox' event (evid: 1812)
 *
 * Event description: Answers PP - Close lightbox on any step with closing method attribute: click on X button
 *
 * @param {appPremiumPackagePickerUserClosedPpLightBoxParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers product plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - Yearly/monthly
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerUserClosedPpLightBoxParams>} LogObject<appPremiumPackagePickerUserClosedPpLightBoxParams>
 */
export function appPremiumPackagePickerUserClosedPpLightBox(params) {
    return { evid: 1812, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerFirstStepUserSelectTeamSize' event (evid: 1813)
 *
 * Event description: Answers PP First step - User select team size (radio button) :
 * {2-5, 6-10, 11-20, 21-50, 51-100,100+ (-1)}
 * (All 'product' and 'plan' attributes will be NULL when the other steps are not exposed but not if they changed after advanced steps.)
 *
 * @param {appPremiumPackagePickerFirstStepUserSelectTeamSizeParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - plan price depend on tenant selection of number of agents and plan selection
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - monthly/yearly subscription
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerFirstStepUserSelectTeamSizeParams>} LogObject<appPremiumPackagePickerFirstStepUserSelectTeamSizeParams>
 */
export function appPremiumPackagePickerFirstStepUserSelectTeamSize(params) {
    return { evid: 1813, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepProductCheckboxChecked' event (evid: 1814)
 *
 * Event description: Answers PP - Second step: user checked on one of the products checkboxes : KB/ Ticketing(HD)/ Call center. (custom as plan type)
 * for example:
 * checked_product: Call center
 * product_call_center=1
 * product_ticketing =0
 * product_knowledge_base=0
 *
 * @param {appPremiumPackagePickerSecondStepProductCheckboxCheckedParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} checked_product - checked product: KB, Ticketing (HD), Call center
 * @property {string} subscription_type - monthly/yearly subscription
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerSecondStepProductCheckboxCheckedParams>} LogObject<appPremiumPackagePickerSecondStepProductCheckboxCheckedParams>
 */
export function appPremiumPackagePickerSecondStepProductCheckboxChecked(params) {
    return { evid: 1814, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepUserUncheckedProduct' event (evid: 1815)
 *
 * Event description: Answers Package Picker - Second step - User unchecked product checkbox on Custom plan type: uncheck call center/uncheck knowledge base/uncheck ticketing.
 * for example:
 * product_call_center=0
 * product_ticketing =0
 * product_knowledge_base=0
 * and unchecked_product: Call center
 *
 * @param {appPremiumPackagePickerSecondStepUserUncheckedProductParams} params - The parameters for this event
 * @property {boolean} product_call_center - 1- if call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - 1- if knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {string} unchecked_product - product that was unchecked
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - Yearly / Monthly
 * @property {boolean} product_ticketing - 1- if ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerSecondStepUserUncheckedProductParams>} LogObject<appPremiumPackagePickerSecondStepUserUncheckedProductParams>
 */
export function appPremiumPackagePickerSecondStepUserUncheckedProduct(params) {
    return { evid: 1815, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlan' event (evid: 1816)
 *
 * Event description: Answers PP Second step - User clicked on Unlimited plan select button or 3 products custom plan selected
 *
 * @param {appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge_base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step user click
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Unlimited plan/ Custom plan
 * @property {string} origin - upgrade origin component
 * @property {boolean} unlimited_selected - relevant only for unlimited plan: user select unlimited =1 ,user checked 3 products=0
 * @property {number} plan_price - Total Answers plan price
 * @property {string} team_size - The max number of agents
 * @property {string} subscription_type - monthly/yearly subscription
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams>} LogObject<appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams>
 */
export function appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlan(params) {
    return { evid: 1816, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerThirdStepChooseSubscriptionCycle' event (evid: 1817)
 *
 * Event description: Answers PP Third step - Choose Answers subscription cycle:
 * Monthly / Yearly
 *
 * @param {appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers total plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - Monthly / Yearly
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams>} LogObject<appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams>
 */
export function appPremiumPackagePickerThirdStepChooseSubscriptionCycle(params) {
    return { evid: 1817, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerProceedToCheckoutClick' event (evid: 1818)
 *
 * Event description: Answers PP last step
 *
 * @param {appPremiumPackagePickerProceedToCheckoutClickParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - monthly/ yearly
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerProceedToCheckoutClickParams>} LogObject<appPremiumPackagePickerProceedToCheckoutClickParams>
 */
export function appPremiumPackagePickerProceedToCheckoutClick(params) {
    return { evid: 1818, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserClosedUpgradeSuccessLightBox' event (evid: 1819)
 *
 * Event description: Answers PP last step:  upgrade success lightbox closed.
 * Method is for user closing action: user click on okay button /click outside of the lightbox
 *
 * @param {appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers product price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - Yearly/monthly
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams>} LogObject<appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams>
 */
export function appPremiumPackagePickerUserClosedUpgradeSuccessLightBox(params) {
    return { evid: 1819, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepContactUsClickOnLink' event (evid: 1820)
 *
 * Event description: Answers PP - Second step - Contact us user click on the contact link - vip@wixanswers.com mail after choosing  maximum num of agents (101+ agents)
 *
 * @param {appPremiumPackagePickerSecondStepContactUsClickOnLinkParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} from_step - last step user click
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - upgrade origin component
 * @return {LogObject<appPremiumPackagePickerSecondStepContactUsClickOnLinkParams>} LogObject<appPremiumPackagePickerSecondStepContactUsClickOnLinkParams>
 */
export function appPremiumPackagePickerSecondStepContactUsClickOnLink(params) {
    return { evid: 1820, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerLoadStarted' event (evid: 1821)
 *
 * Event description: User opens the Package Picker and it starts to load
 *
 * @param {appPremiumPackagePickerLoadStartedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @return {LogObject<appPremiumPackagePickerLoadStartedParams>} LogObject<appPremiumPackagePickerLoadStartedParams>
 */
export function appPremiumPackagePickerLoadStarted(params) {
    return { evid: 1821, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerLoadSuccess' event (evid: 1822)
 *
 * Event description: User opens the Package Picker and it loads successfully
 *
 * @param {appPremiumPackagePickerLoadSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {number} tts - Time since load started in ms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @return {LogObject<appPremiumPackagePickerLoadSuccessParams>} LogObject<appPremiumPackagePickerLoadSuccessParams>
 */
export function appPremiumPackagePickerLoadSuccess(params) {
    return { evid: 1822, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerHoverOnPackage' event (evid: 1823)
 *
 * Event description: App (Premium) - Package Picker - Hover on Package.
 *
 * @param {appPremiumPackagePickerHoverOnPackageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @return {LogObject<appPremiumPackagePickerHoverOnPackageParams>} LogObject<appPremiumPackagePickerHoverOnPackageParams>
 */
export function appPremiumPackagePickerHoverOnPackage(params) {
    return { evid: 1823, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectPackage' event (evid: 1824)
 *
 * Event description: User selects premium package - CTA click (Unlimited / Multi-Channel / Self-Service / Call Center)
 *
 * @param {appPremiumPackagePickerSelectPackageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerSelectPackageParams>} LogObject<appPremiumPackagePickerSelectPackageParams>
 */
export function appPremiumPackagePickerSelectPackage(params) {
    return { evid: 1824, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectTeamSize' event (evid: 1825)
 *
 * Event description: User selects team size (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * @param {appPremiumPackagePickerSelectTeamSizeParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerSelectTeamSizeParams>} LogObject<appPremiumPackagePickerSelectTeamSizeParams>
 */
export function appPremiumPackagePickerSelectTeamSize(params) {
    return { evid: 1825, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectSubscriptionCycle' event (evid: 1826)
 *
 * Event description: User selects subscription cycle - the whole strip is clickable, not just radio button (Monthly / Yearly / 2 Years)
 *
 * @param {appPremiumPackagePickerSelectSubscriptionCycleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerSelectSubscriptionCycleParams>} LogObject<appPremiumPackagePickerSelectSubscriptionCycleParams>
 */
export function appPremiumPackagePickerSelectSubscriptionCycle(params) {
    return { evid: 1826, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerOrderPreviewRendered' event (evid: 1827)
 *
 * Event description: Order preview is rendered
 *
 * @param {appPremiumPackagePickerOrderPreviewRenderedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} tts - Time since load started in ms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {GUID} preview_id - ID of the order preview
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerOrderPreviewRenderedParams>} LogObject<appPremiumPackagePickerOrderPreviewRenderedParams>
 */
export function appPremiumPackagePickerOrderPreviewRendered(params) {
    return { evid: 1827, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerEnterpriseRequestCallback' event (evid: 1828)
 *
 * Event description: User requests callback (CTA button) after selecting the enterprise solution (50+), which opens the widget
 *
 * @param {appPremiumPackagePickerEnterpriseRequestCallbackParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerEnterpriseRequestCallbackParams>} LogObject<appPremiumPackagePickerEnterpriseRequestCallbackParams>
 */
export function appPremiumPackagePickerEnterpriseRequestCallback(params) {
    return { evid: 1828, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutAttempt' event (evid: 1829)
 *
 * Event description: User attempts to checkout (CTA button)
 *
 * @param {appPremiumPackagePickerCheckoutAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerCheckoutAttemptParams>} LogObject<appPremiumPackagePickerCheckoutAttemptParams>
 */
export function appPremiumPackagePickerCheckoutAttempt(params) {
    return { evid: 1829, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutSuccess' event (evid: 1830)
 *
 * Event description: User succeeds to checkout - Zuora iframe is rendered
 *
 * @param {appPremiumPackagePickerCheckoutSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} tts - Time since load started in ms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerCheckoutSuccessParams>} LogObject<appPremiumPackagePickerCheckoutSuccessParams>
 */
export function appPremiumPackagePickerCheckoutSuccess(params) {
    return { evid: 1830, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutFail' event (evid: 1831)
 *
 * Event description: User fails to checkout - Zuora iframe cannot be rendered
 *
 * @param {appPremiumPackagePickerCheckoutFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerCheckoutFailParams>} LogObject<appPremiumPackagePickerCheckoutFailParams>
 */
export function appPremiumPackagePickerCheckoutFail(params) {
    return { evid: 1831, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseAttempt' event (evid: 1832)
 *
 * Event description: App (Premium) - Package Picker - Purchase Attempt.
 *
 * @param {appPremiumPackagePickerPurchaseAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseAttemptParams>} LogObject<appPremiumPackagePickerPurchaseAttemptParams>
 */
export function appPremiumPackagePickerPurchaseAttempt(params) {
    return { evid: 1832, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseSuccess' event (evid: 1833)
 *
 * Event description: User succeeds to purchase
 *
 * @param {appPremiumPackagePickerPurchaseSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} tts - Time since load started in ms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseSuccessParams>} LogObject<appPremiumPackagePickerPurchaseSuccessParams>
 */
export function appPremiumPackagePickerPurchaseSuccess(params) {
    return { evid: 1833, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseFail' event (evid: 1834)
 *
 * Event description: User fails to purchase
 *
 * @param {appPremiumPackagePickerPurchaseFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error reason
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseFailParams>} LogObject<appPremiumPackagePickerPurchaseFailParams>
 */
export function appPremiumPackagePickerPurchaseFail(params) {
    return { evid: 1834, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseModalLinkClick' event (evid: 1835)
 *
 * Event description: User clicks link from modal after purchase success or fail
 *
 * @param {appPremiumPackagePickerPurchaseModalLinkClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {Url} link_name - Link clicked
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} modal_name - Modal name (success / failure)
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseModalLinkClickParams>} LogObject<appPremiumPackagePickerPurchaseModalLinkClickParams>
 */
export function appPremiumPackagePickerPurchaseModalLinkClick(params) {
    return { evid: 1835, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerWhatSInsideHover' event (evid: 1836)
 *
 * Event description: User hovers on "What's Inside" - tip tool
 *
 * @param {appPremiumPackagePickerWhatSInsideHoverParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} from_step - PP step user takes the action from (1 / 2 / 3)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerWhatSInsideHoverParams>} LogObject<appPremiumPackagePickerWhatSInsideHoverParams>
 */
export function appPremiumPackagePickerWhatSInsideHover(params) {
    return { evid: 1836, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerGoBackToPreviousStep' event (evid: 1837)
 *
 * Event description: User clicks button to go back to previous page
 *
 * @param {appPremiumPackagePickerGoBackToPreviousStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} from_step - PP step user takes the action from (1 / 2 / 3)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerGoBackToPreviousStepParams>} LogObject<appPremiumPackagePickerGoBackToPreviousStepParams>
 */
export function appPremiumPackagePickerGoBackToPreviousStep(params) {
    return { evid: 1837, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPreviewRenderFail' event (evid: 1839)
 *
 * Event description: Order preview fails to render
 *
 * @param {appPremiumPackagePickerPreviewRenderFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPreviewRenderFailParams>} LogObject<appPremiumPackagePickerPreviewRenderFailParams>
 */
export function appPremiumPackagePickerPreviewRenderFail(params) {
    return { evid: 1839, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksIncentiveView' event (evid: 1851)
 *
 * Event description: An user views a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksIncentiveViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksIncentiveViewParams>} LogObject<appPremiumBlocksIncentiveViewParams>
 */
export function appPremiumBlocksIncentiveView(params) {
    return { evid: 1851, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksIncentiveCtaClick' event (evid: 1852)
 *
 * Event description: A user clicks on a CTA in a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksIncentiveCtaClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksIncentiveCtaClickParams>} LogObject<appPremiumBlocksIncentiveCtaClickParams>
 */
export function appPremiumBlocksIncentiveCtaClick(params) {
    return { evid: 1852, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksCreditIncentiveView' event (evid: 1853)
 *
 * Event description: An user views a call center credit incentive
 *
 * @param {appPremiumBlocksCreditIncentiveViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksCreditIncentiveViewParams>} LogObject<appPremiumBlocksCreditIncentiveViewParams>
 */
export function appPremiumBlocksCreditIncentiveView(params) {
    return { evid: 1853, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksCreditIncentiveIncentiveCtaClick' event (evid: 1854)
 *
 * Event description: A user clicks on a CTA in a call center credit incentive
 *
 * @param {appPremiumBlocksCreditIncentiveIncentiveCtaClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksCreditIncentiveIncentiveCtaClickParams>} LogObject<appPremiumBlocksCreditIncentiveIncentiveCtaClickParams>
 */
export function appPremiumBlocksCreditIncentiveIncentiveCtaClick(params) {
    return { evid: 1854, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksPremiumIncentiveContactUsClick' event (evid: 1855)
 *
 * Event description: A user clicks on the "Contact Us" button in a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksPremiumIncentiveContactUsClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksPremiumIncentiveContactUsClickParams>} LogObject<appPremiumBlocksPremiumIncentiveContactUsClickParams>
 */
export function appPremiumBlocksPremiumIncentiveContactUsClick(params) {
    return { evid: 1855, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsOpenCccModal' event (evid: 1861)
 *
 * Event description: Call Center Credits (CCC) modal lightbox appears successfully
 *
 * @param {appPremiumCcCreditsOpenCccModalParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsOpenCccModalParams>} LogObject<appPremiumCcCreditsOpenCccModalParams>
 */
export function appPremiumCcCreditsOpenCccModal(params) {
    return { evid: 1861, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCloseCccModal' event (evid: 1862)
 *
 * Event description: Call Center Credits (CCC) modal lightbox closed
 *
 * @param {appPremiumCcCreditsCloseCccModalParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsCloseCccModalParams>} LogObject<appPremiumCcCreditsCloseCccModalParams>
 */
export function appPremiumCcCreditsCloseCccModal(params) {
    return { evid: 1862, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsModalCtaClick' event (evid: 1863)
 *
 * Event description: User clicked on the Call Center Credits (CCC) modal CTA (to the premium plans PP or the credits PP)
 *
 * @param {appPremiumCcCreditsModalCtaClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsModalCtaClickParams>} LogObject<appPremiumCcCreditsModalCtaClickParams>
 */
export function appPremiumCcCreditsModalCtaClick(params) {
    return { evid: 1863, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsOpenPackagePicker' event (evid: 1864)
 *
 * Event description: Call Center Credits (CCC) Package Picker opened successfully.
 *
 * @param {appPremiumCcCreditsOpenPackagePickerParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsOpenPackagePickerParams>} LogObject<appPremiumCcCreditsOpenPackagePickerParams>
 */
export function appPremiumCcCreditsOpenPackagePicker(params) {
    return { evid: 1864, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsSelectAmountForPurchase' event (evid: 1865)
 *
 * Event description: User selected the amount of call center credits for purchase
 *
 * @param {appPremiumCcCreditsSelectAmountForPurchaseParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} credits_amount - Selected amount of credits
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsSelectAmountForPurchaseParams>} LogObject<appPremiumCcCreditsSelectAmountForPurchaseParams>
 */
export function appPremiumCcCreditsSelectAmountForPurchase(params) {
    return { evid: 1865, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsClickOnCheckout' event (evid: 1866)
 *
 * Event description: User attempts to proceed to the call center credits checkout
 *
 * @param {appPremiumCcCreditsClickOnCheckoutParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} credits_amount - Selected amount of credits
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsClickOnCheckoutParams>} LogObject<appPremiumCcCreditsClickOnCheckoutParams>
 */
export function appPremiumCcCreditsClickOnCheckout(params) {
    return { evid: 1866, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCreditPurchaseSuccessLb' event (evid: 1867)
 *
 * Event description: Call center credits purchase success lightbox appears
 *
 * @param {appPremiumCcCreditsCreditPurchaseSuccessLbParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @return {LogObject<appPremiumCcCreditsCreditPurchaseSuccessLbParams>} LogObject<appPremiumCcCreditsCreditPurchaseSuccessLbParams>
 */
export function appPremiumCcCreditsCreditPurchaseSuccessLb(params) {
    return { evid: 1867, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCreditPurchaseFailLb' event (evid: 1868)
 *
 * Event description: Call center credits purchase fail lightbox appears
 *
 * @param {appPremiumCcCreditsCreditPurchaseFailLbParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @return {LogObject<appPremiumCcCreditsCreditPurchaseFailLbParams>} LogObject<appPremiumCcCreditsCreditPurchaseFailLbParams>
 */
export function appPremiumCcCreditsCreditPurchaseFailLb(params) {
    return { evid: 1868, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appGeneralWelcomeLightboxView' event (evid: 1901)
 *
 * Event description: The Answers welcome lightbox was viewed by the user. Event avaiable since 2018-10-11
 *
 * @param {appGeneralWelcomeLightboxViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} type - The type of the welcome message (Freemium, Trial, etc.)
 * @return {LogObject<appGeneralWelcomeLightboxViewParams>} LogObject<appGeneralWelcomeLightboxViewParams>
 */
export function appGeneralWelcomeLightboxView(params) {
    return { evid: 1901, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxView' event (evid: 1947)
 *
 * Event description: First Time User Experience (FTUE) Video Lightbox of a certain feature was viewed by the user
 *
 * @param {appGeneralFtueVideoLightboxViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} feature - Name of the feature the lightbox is shown in
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appGeneralFtueVideoLightboxViewParams>} LogObject<appGeneralFtueVideoLightboxViewParams>
 */
export function appGeneralFtueVideoLightboxView(params) {
    return { evid: 1947, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxPlayVideo' event (evid: 1948)
 *
 * Event description: User clicks the "Play" button of the video in the First Time User Experience (FTUE) Video Lightbox of a certain feature
 *
 * @param {appGeneralFtueVideoLightboxPlayVideoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} feature - Name of the feature the lightbox is shown in
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appGeneralFtueVideoLightboxPlayVideoParams>} LogObject<appGeneralFtueVideoLightboxPlayVideoParams>
 */
export function appGeneralFtueVideoLightboxPlayVideo(params) {
    return { evid: 1948, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxClose' event (evid: 1949)
 *
 * Event description: First Time User Experience (FTUE) Video Lightbox of a certain feature was closed by the user
 *
 * @param {appGeneralFtueVideoLightboxCloseParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} feature - Name of the feature the lightbox is shown in
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appGeneralFtueVideoLightboxCloseParams>} LogObject<appGeneralFtueVideoLightboxCloseParams>
 */
export function appGeneralFtueVideoLightboxClose(params) {
    return { evid: 1949, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appGeneralPageLoadAttempt' event (evid: 1950)
 *
 * Event description: General event - like "page view". This event is sent after the app is already loaded, and the specific page/module is starting to load
 *
 * @param {appGeneralPageLoadAttemptParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} module - module
 * @property {GUID} tenant_id - tenant_id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {Url} page_url - page_url
 * @return {LogObject<appGeneralPageLoadAttemptParams>} LogObject<appGeneralPageLoadAttemptParams>
 */
export function appGeneralPageLoadAttempt(params) {
    return { evid: 1950, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appGeneralPageLoadSuccess' event (evid: 1951)
 *
 * Event description: General event - like "page view"
 *
 * @param {appGeneralPageLoadSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} module - module
 * @property {GUID} tenant_id - tenant_id
 * @property {number} screen_resolution_height - Screen resolution height
 * @property {string} permission_level - User's permission level
 * @property {number} screen_resolution_width - Screen resolution width
 * @property {GUID} answers_role_id - Answers Role ID
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - View Port width
 * @property {GUID} user_id - user_id
 * @property {string} pixel_ratio - Device Pixel Ratio
 * @property {number} screen_height - View Port height
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {Url} page_url - page_url
 * @return {LogObject<appGeneralPageLoadSuccessParams>} LogObject<appGeneralPageLoadSuccessParams>
 */
export function appGeneralPageLoadSuccess(params) {
    return { evid: 1951, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appGeneralPageLoadFail' event (evid: 1952)
 *
 * Event description: General event - like "page view"
 *
 * @param {appGeneralPageLoadFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} module - module
 * @property {GUID} tenant_id - tenant_id
 * @property {string} permission_level - User's permission level
 * @property {string} errorReason - reason for fail
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {Url} page_url - page_url
 * @return {LogObject<appGeneralPageLoadFailParams>} LogObject<appGeneralPageLoadFailParams>
 */
export function appGeneralPageLoadFail(params) {
    return { evid: 1952, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicPageViewArticle' event (evid: 1997)
 *
 * Event description: Article - page view
 *
 * @param {publicPageViewArticleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {GUID} sub_category_id - sub_category_id
 * @property {string} category_name - category_name
 * @property {string} source_type - {Help center/widget}
 * @property {GUID} client_id - client id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} sub_category_name - sub_category_name
 * @property {string} article_type - {article/feature request/bug...}
 * @property {string} source_name - source_name
 * @property {GUID} article_id - article_id
 * @property {GUID} source_id - help center/ widget id
 * @property {GUID} category_id - category_id
 * @property {string} article_name - article_name
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewArticleParams>} LogObject<publicPageViewArticleParams>
 */
export function publicPageViewArticle(params) {
    return { evid: 1997, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicPageViewTicket' event (evid: 1998)
 *
 * Event description: Ticket - page view
 *
 * @param {publicPageViewTicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewTicketParams>} LogObject<publicPageViewTicketParams>
 */
export function publicPageViewTicket(params) {
    return { evid: 1998, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicPageViewCategory' event (evid: 1999)
 *
 * Event description: Category/subcategory - page view
 *
 * @param {publicPageViewCategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {GUID} sub_category_id - sub_category_id
 * @property {string} category_name - category_name
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} sub_category_name - sub_category_name
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - category_id
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewCategoryParams>} LogObject<publicPageViewCategoryParams>
 */
export function publicPageViewCategory(params) {
    return { evid: 1999, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicPageView' event (evid: 2001)
 *
 * Event description: page view (similar to evid 531 in src 4)
 *
 * @param {publicPageViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - {help center/widget}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - examples: {widget_123, yotpo_help_center1...}
 * @property {GUID} source_id - source_id
 * @property {string} page_type - the type of the viewed page (for ex. home page, article, ticket..)
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewParams>} LogObject<publicPageViewParams>
 */
export function publicPageView(params) {
    return { evid: 2001, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicVoteForArticle' event (evid: 2002)
 *
 * Event description: Click on "Thumbs up/down" (similar to evid 501 in src 4)
 *
 * @param {publicVoteForArticleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - Tenant ID
 * @property {boolean} thumbs_up - {true, false}
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - Article ID
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - Category ID
 * @property {string} parent_url - parent_url (widget)
 * @property {string} clicked_text - the text of the option the user clicked
 * @return {LogObject<publicVoteForArticleParams>} LogObject<publicVoteForArticleParams>
 */
export function publicVoteForArticle(params) {
    return { evid: 2002, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicVoteForFeatureRequest' event (evid: 2003)
 *
 * Event description: Vote/un-vote for wish list (similar to evid 502 in src 4)
 *
 * @param {publicVoteForFeatureRequestParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - Tenant ID
 * @property {boolean} thumbs_up - {true, false}
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - Article ID
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - Category ID
 * @property {string} parent_url - in case of a widget
 * @return {LogObject<publicVoteForFeatureRequestParams>} LogObject<publicVoteForFeatureRequestParams>
 */
export function publicVoteForFeatureRequest(params) {
    return { evid: 2003, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicVoteForKnownIssue' event (evid: 2004)
 *
 * Event description: Click the (I have this problem (bug)) (similar to evid 503 in src 4)
 *
 * @param {publicVoteForKnownIssueParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - Tenant ID
 * @property {boolean} thumbs_up - {true, false}
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - Article ID
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - Category ID
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicVoteForKnownIssueParams>} LogObject<publicVoteForKnownIssueParams>
 */
export function publicVoteForKnownIssue(params) {
    return { evid: 2004, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSearch' event (evid: 2005)
 *
 * Event description: asking a question (similar to evid 520 in src 4)
 *
 * @param {publicSearchParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers brand id
 * @property {GUID} result_article_id_1 - result_article_id_1
 * @property {string} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} search_term - search_term
 * @property {number} results_count - number of search results
 * @property {string} source_name - source_name
 * @property {GUID} result_article_id_2 - result_article_id_2
 * @property {GUID} source_id - source_id
 * @property {GUID} result_article_id_3 - result_article_id_3
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSearchParams>} LogObject<publicSearchParams>
 */
export function publicSearch(params) {
    return { evid: 2005, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSelectSearchResult' event (evid: 2006)
 *
 * Event description: click on answer (similar to evid 521 in src 4)
 *
 * @param {publicSelectSearchResultParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} question - user's search terms (question)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} search_term - search term which lead to this answer
 * @property {string} source_name - source_name
 * @property {GUID} article_id - Article ID
 * @property {GUID} source_id - source_id
 * @property {string} answer - The selected answer
 * @property {GUID} category_id - Category ID
 * @property {number} answer_index - index of answer (1,2,3,4,5..)
 * @property {string} parent_url - widget's parent page
 * @property {string} search_result_selection - From where the user picked the answer (dropdown/search results page)
 * @return {LogObject<publicSelectSearchResultParams>} LogObject<publicSelectSearchResultParams>
 */
export function publicSelectSearchResult(params) {
    return { evid: 2006, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSeeAllResults' event (evid: 2007)
 *
 * Event description: click the (see all results) link (similar to evid 522 in src 4)
 *
 * @param {publicSeeAllResultsParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers brand id
 * @property {GUID} result_article_id_1 - result_article_id_1
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} search_term - search_term
 * @property {string} source_name - source_name
 * @property {GUID} result_article_id_2 - result_article_id_2
 * @property {GUID} source_id - source_id
 * @property {GUID} result_article_id_3 - result_article_id_3
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSeeAllResultsParams>} LogObject<publicSeeAllResultsParams>
 */
export function publicSeeAllResults(params) {
    return { evid: 2007, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicNoSearchResults' event (evid: 2008)
 *
 * Event description: got no answer (similar to evid 537 in src 4)
 *
 * @param {publicNoSearchResultsParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers brand id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} search_term - search_term
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicNoSearchResultsParams>} LogObject<publicNoSearchResultsParams>
 */
export function publicNoSearchResults(params) {
    return { evid: 2008, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicPageViewError' event (evid: 2009)
 *
 * Event description: page view error
 *
 * @param {publicPageViewErrorParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} errorReason - Error Reason
 * @property {string} source_type - {help center/widget}
 * @property {GUID} client_id - Client ID
 * @property {GUID} user_id - user_id
 * @property {string} locale - Answers language
 * @property {string} source_name - examples: {widget_123, yotpo_help_center1...}
 * @property {GUID} source_id - source_id
 * @property {string} page_type - the type of the viewed page (for ex. home page, article, ticket..)
 * @property {Url} page_url - The page's URL
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewErrorParams>} LogObject<publicPageViewErrorParams>
 */
export function publicPageViewError(params) {
    return { evid: 2009, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSelectCategoryOrSubcategory' event (evid: 2010)
 *
 * Event description: Clicking on a category or a subcategory from the main screen (similar to event 519 in source 4)
 *
 * @param {publicSelectCategoryOrSubcategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} category_name - category name
 * @property {string} widget_name - widget name
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - category id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSelectCategoryOrSubcategoryParams>} LogObject<publicSelectCategoryOrSubcategoryParams>
 */
export function publicSelectCategoryOrSubcategory(params) {
    return { evid: 2010, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicWidgetWidgetLauncherLoadedClient' event (evid: 2014)
 *
 * Event description: The event is trigger when a launcher is loaded
 *
 * @param {publicWidgetWidgetLauncherLoadedClientParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @return {LogObject<publicWidgetWidgetLauncherLoadedClientParams>} LogObject<publicWidgetWidgetLauncherLoadedClientParams>
 */
export function publicWidgetWidgetLauncherLoadedClient(params) {
    return { evid: 2014, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicWidgetToggleModule' event (evid: 2230)
 *
 * Event description: Click on the top icon to switch between "contact" and "help"
 *
 * @param {publicWidgetToggleModuleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - where the widget is opened from (source page name)
 * @property {string} widget_name - widget name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} parent_url - parent_url
 * @property {string} switch_to - the new state of the widget
 * @return {LogObject<publicWidgetToggleModuleParams>} LogObject<publicWidgetToggleModuleParams>
 */
export function publicWidgetToggleModule(params) {
    return { evid: 2230, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicWidgetSuggestedArticlesResolved' event (evid: 2240)
 *
 * Event description: After Clicking on one of the suggested articles from inside a ticket submission (only in a widget!!), click on "Yes! my issues was resolved".
 *
 * @param {publicWidgetSuggestedArticlesResolvedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - where the widget is opened from (source page name)
 * @property {string} widget_name - widget name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {GUID} article_id - selected article id
 * @property {string} article_name - selected article name
 * @property {string} parent_url - parent_url
 * @return {LogObject<publicWidgetSuggestedArticlesResolvedParams>} LogObject<publicWidgetSuggestedArticlesResolvedParams>
 */
export function publicWidgetSuggestedArticlesResolved(params) {
    return { evid: 2240, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicWidgetSuggestedArticlesReport' event (evid: 2250)
 *
 * Event description: After Clicking on one of the suggested articles from inside a ticket submission (only in a widget!!), click on "No! I want to report my issue".
 *
 * @param {publicWidgetSuggestedArticlesReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - where the widget is opened from (source page name)
 * @property {string} widget_name - widget name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {GUID} article_id - selected article id
 * @property {string} article_name - selected article name
 * @property {string} parent_url - parent_url
 * @return {LogObject<publicWidgetSuggestedArticlesReportParams>} LogObject<publicWidgetSuggestedArticlesReportParams>
 */
export function publicWidgetSuggestedArticlesReport(params) {
    return { evid: 2250, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicWismoChatbotStepReached' event (evid: 2260)
 *
 * Event description: Public (Wismo chatbot) - step reached.
 *
 * @param {publicWismoChatbotStepReachedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - tenant_id
 * @property {GUID} widget_id - widget_id
 * @property {GUID} session_id - wismo chat bot session id
 * @property {string} data - json formatted string, containing all info on the current chat bot step, including step id, type, ticket id if created, etc.
 * @property {string} user_device_type - the device type of the user - Desktop, Tablet, Smartphone, Feature Phone, Smart-TV, Robot, Other non-Mobile, Other Mobile.
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<publicWismoChatbotStepReachedParams>} LogObject<publicWismoChatbotStepReachedParams>
 */
export function publicWismoChatbotStepReached(params) {
    return { evid: 2260, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicChatbotTicketCreatedFromTheChatbot' event (evid: 2261)
 *
 * Event description: Public (Chatbot) - Ticket created from the chatbot.
 *
 * @param {publicChatbotTicketCreatedFromTheChatbotParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id that user opened from the chat bot
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - tenant_id
 * @property {GUID} session_id - session_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @return {LogObject<publicChatbotTicketCreatedFromTheChatbotParams>} LogObject<publicChatbotTicketCreatedFromTheChatbotParams>
 */
export function publicChatbotTicketCreatedFromTheChatbot(params) {
    return { evid: 2261, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicCustomerPortalViewerClientEngagement' event (evid: 2400)
 *
 * Event description: Public (Customer Portal) - Viewer Client Engagement.
 *
 * @param {publicCustomerPortalViewerClientEngagementParams} params - The parameters for this event
 * @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with.
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} data - Json of Data related to the member's engagement.
 * @property {string} engaged_component - What "component" the member clicked/engaged with.
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} engagement_name - The name of the Engagement
 * @property {string} lang - Answers language
 * @return {LogObject<publicCustomerPortalViewerClientEngagementParams>} LogObject<publicCustomerPortalViewerClientEngagementParams>
 */
export function publicCustomerPortalViewerClientEngagement(params) {
    return { evid: 2400, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicCustomerPortalViewerPageLoadSuccess' event (evid: 2401)
 *
 * Event description: This Event is triggered every time Customer Portal viewer page is Loaded Successfully
 *
 * @param {publicCustomerPortalViewerPageLoadSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {boolean} is_user_ticket_ccd - Is the ticket viewer cc'd to the ticket? relevant only for section_key = Ticket page
 * @property {boolean} is_status_filtered - Relevant only for section_key = support requests list
 * @property {boolean} is_company_filtered - Relevant only for section_key = support requests list
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {boolean} is_reporter_filtered - Relevant only for section_key = support requests list
 * @property {boolean} page_has_contact_us_button - Does the contact us buttons are visible in the page (True or False)
 * @property {boolean} is_language_filtered - Relevant only for section_key = support requests list
 * @property {boolean} is_page_load_from_portal - Is the load of the ticket page is happening internally from the portal (True) or is it stand alone (False) - relevant only for section_key = Ticket page
 * @property {string} section_key - Support requests/followed articles/ticket page
 * @property {string} lang - Answers language
 * @property {boolean} is_user_ticket_reporter - Is the ticket viewer (user) also the ticket reporter? relevant only for section_key = Ticket page
 * @property {boolean} page_has_custom_fields - If section_key = support requests - does custom fields column presented, if section_key = ticket page - does custom fields presented in the info panel
 * @return {LogObject<publicCustomerPortalViewerPageLoadSuccessParams>} LogObject<publicCustomerPortalViewerPageLoadSuccessParams>
 */
export function publicCustomerPortalViewerPageLoadSuccess(params) {
    return { evid: 2401, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicClickContactUsFooter' event (evid: 2500)
 *
 * Event description: Click on "Contact Us"
 *
 * @param {publicClickContactUsFooterParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} location_identifier - header/footer
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name
 * @property {GUID} source_id - source_id
 * @return {LogObject<publicClickContactUsFooterParams>} LogObject<publicClickContactUsFooterParams>
 */
export function publicClickContactUsFooter(params) {
    return { evid: 2500, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSubmitTicketAttempt' event (evid: 2510)
 *
 * Event description: Submission attempt for feedback following an unhelpful vote for an article
 *
 * @param {publicSubmitTicketAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject
 * @property {Url} referral_url - referral_url
 * @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
 * @property {boolean} is_attached - if there is an attachment
 * @property {string} description - Ticket content
 * @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - null if form_source is = 1
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSubmitTicketAttemptParams>} LogObject<publicSubmitTicketAttemptParams>
 */
export function publicSubmitTicketAttempt(params) {
    return { evid: 2510, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSubmitTicketValidationError' event (evid: 2511)
 *
 * Event description: Public - "Submit Ticket" - validation error
 *
 * @param {publicSubmitTicketValidationErrorParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject
 * @property {Url} referral_url - referral_url
 * @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
 * @property {boolean} is_attached - if there is an attachment
 * @property {string} description - Ticket content
 * @property {boolean} error_in_costume_field - error_in_costume_field
 * @property {boolean} error_in_description - Has error in description?
 * @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {boolean} error_in_name - error_in_name
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - null if form_source is = 1
 * @property {boolean} error_in_email - error_in_email
 * @property {GUID} source_id - source_id
 * @property {boolean} error_in_subject - Has error in subject?
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSubmitTicketValidationErrorParams>} LogObject<publicSubmitTicketValidationErrorParams>
 */
export function publicSubmitTicketValidationError(params) {
    return { evid: 2511, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSubmitTicketSuccess' event (evid: 2512)
 *
 * Event description: Successful submission feedback following an unhelpful vote for an article
 *
 * @param {publicSubmitTicketSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject
 * @property {Url} referral_url - referral_url
 * @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
 * @property {boolean} is_attached - if there is an attachment
 * @property {string} description - Ticket content
 * @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - null if form_source is = 1
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSubmitTicketSuccessParams>} LogObject<publicSubmitTicketSuccessParams>
 */
export function publicSubmitTicketSuccess(params) {
    return { evid: 2512, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSubmitTicketCancel' event (evid: 2520)
 *
 * Event description: Cancel the ticket submission
 *
 * @param {publicSubmitTicketCancelParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject
 * @property {Url} referral_url - referral_url
 * @property {boolean} is_attached - if there is an attachment
 * @property {string} description - Ticket content
 * @property {string} form_source - {Contact , article...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - null if form_source is = 1
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSubmitTicketCancelParams>} LogObject<publicSubmitTicketCancelParams>
 */
export function publicSubmitTicketCancel(params) {
    return { evid: 2520, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicSuggestedArticlesClick' event (evid: 2530)
 *
 * Event description: Clicking on one of the suggested articles from inside a ticket submission.
 *
 * @param {publicSuggestedArticlesClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject (used as search term for suggested articles)
 * @property {Url} referral_url - referral_url
 * @property {string} description - Ticket content (used as search term for suggested articles)
 * @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {GUID} source_article_id - null if form_source is = 1
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {GUID} selected_article_id - selected article id
 * @property {string} selected_article_name - selected article name
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSuggestedArticlesClickParams>} LogObject<publicSuggestedArticlesClickParams>
 */
export function publicSuggestedArticlesClick(params) {
    return { evid: 2530, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicDidThisArticleHelpBannerLoaded' event (evid: 2531)
 *
 * Event description: The event is triggered when a "Did this article help?" banner is loaded while a user is viewing an article. (currently the only flow that should lead to this, is after a user clicks this article in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation))
 *
 * @param {publicDidThisArticleHelpBannerLoadedParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id that the article was recommended for
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} locale - Answers language
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @return {LogObject<publicDidThisArticleHelpBannerLoadedParams>} LogObject<publicDidThisArticleHelpBannerLoadedParams>
 */
export function publicDidThisArticleHelpBannerLoaded(params) {
    return { evid: 2531, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicAUserClickOnDidThisArticleHelpBanner' event (evid: 2532)
 *
 * Event description: The event is triggered when a user click "Yes my issue is solved" or "No, I still need help" on "Did this article help?" banner while viewing this article. (currently the only flow that should allow it, is after a user clicks this article in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation))
 *
 * @param {publicAUserClickOnDidThisArticleHelpBannerParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id that the article was recommended for
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} locale - Answers language
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @property {boolean} help_or_not - 0 - "No, I still need help", 1- "Yes my issue is solved"
 * @return {LogObject<publicAUserClickOnDidThisArticleHelpBannerParams>} LogObject<publicAUserClickOnDidThisArticleHelpBannerParams>
 */
export function publicAUserClickOnDidThisArticleHelpBanner(params) {
    return { evid: 2532, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicUserArticleEngagementPing' event (evid: 2533)
 *
 * Event description: When a user visits an article page he will get a "ping" every 15 seconds if he made one or more activity actions : scroll, mouse move and click within those 15 secs. The activity doesn’t have to be continuous, whenever the user shows activity he'll get a ping.
 * when the page view originated in email article recommendation, the ticket id recommended for will be provided.
 *
 * @param {publicUserArticleEngagementPingParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} activity_type - The activity actions which the user performed (array)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} locale - Answers language
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @return {LogObject<publicUserArticleEngagementPingParams>} LogObject<publicUserArticleEngagementPingParams>
 */
export function publicUserArticleEngagementPing(params) {
    return { evid: 2533, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'publicAccessibilityUserActivityInArticles' event (evid: 2540)
 *
 * Event description: Watching video, expand collapsible and clicking on external links in accessibility articles by article_id.
 *
 * @param {publicAccessibilityUserActivityInArticlesParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - The client id of the user who have an activity in the article.
 * @property {GUID} user_id - The user of the user who have an activity in the article.
 * @property {string} category - video,expand,link
 * @return {LogObject<publicAccessibilityUserActivityInArticlesParams>} LogObject<publicAccessibilityUserActivityInArticlesParams>
 */
export function publicAccessibilityUserActivityInArticles(params) {
    return { evid: 2540, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appControlRoomAMemberClientEngagement' event (evid: 2600)
 *
 * Event description: A generic event covering the following member's Client engagements:
 * (1) Click on agent from main table
 * (2) Assign members to channels - data = {multi channel (True/False), multi members (True/False)}
 * (3) Click unassign members  from all channels - data = { multi members (True/False)}
 * (4) Set members workloads - data = {multi channel (True/False), multi members (True/False)}
 * (5) reset members workloads to account settings - data {multi members (True/False)}
 * (6) Update members groups - data = {multi add (True/False), multi remove (True/False), multi members (True/False)}
 * (7) Click on manage groups
 * Update members queues - data = {multi add (True/False), multi remove (True/False), multi members (True/False)}
 * (8) Click on manage queues
 * (9) Click on search bar
 * (10) Start typing in search bar. for more details: https://docs.google.com/document/d/1IT8vPXK0mDTTVnI3TSF3__Ti_dXvB8E2SVZnCwe7AFs/edit
 *
 * @param {appControlRoomAMemberClientEngagementParams} params - The parameters for this event
 * @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with. Examples: (1) Edit Groups modal (2) update queues modal
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} data - Json of Data directly related to the member's click/engagement.
 * @property {string} engaged_component - What "component" the member clicked/engaged with. Examples: main table, upper tool bar, etc.
 * @property {GUID} answers_role_id - Role Id of the Answers member loading the page
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} engagement_name - The engagement the member is doing
 * @property {string} lang - Answers language
 * @return {LogObject<appControlRoomAMemberClientEngagementParams>} LogObject<appControlRoomAMemberClientEngagementParams>
 */
export function appControlRoomAMemberClientEngagement(params) {
    return { evid: 2600, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appControlRoomPageLoadSuccess' event (evid: 2601)
 *
 * Event description: App (Control Room) - Page Load Success.
 *
 * @param {appControlRoomPageLoadSuccessParams} params - The parameters for this event
 * @property {number} whatsapp_workload_position - whatsapp_workload_position
 * @property {number} role_position - The position of this column in the main table, if not presented = 0
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {number} total_call_duration_position - total_call_duration_position
 * @property {number} name_position - The position of this column in the main table, if not presented = 0
 * @property {boolean} is_team - Does this filter applied or not
 * @property {boolean} is_agentchannels - is_agentchannels
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {boolean} is_manager - Does this filter applied or not
 * @property {number} manager_position - The position of this column in the main table, if not presented = 0
 * @property {number} job_title_position - The position of this column in the main table, if not presented = 0
 * @property {number} completed_chats_position - completed_chats_position
 * @property {string} time_frame - The time frame being viewed (Last hour, Last 3 Hours etc.)
 * @property {number} avg_call_duration_position - The position of this column in the main table, if not presented = 0
 * @property {number} team_position - team_position
 * @property {number} facebook_workload_position - The position of this column in the main table, if not presented = 0
 * @property {number} completed_calls_position - The position of this column in the main table, if not presented = 0
 * @property {number} languages_position - The position of this column in the main table, if not presented = 0
 * @property {boolean} is_statuses - Does this filter applied or not
 * @property {number} status_position - The position of this column in the main table, if not presented = 0
 * @property {number} queues_position - The position of this column in the main table, if not presented = 0
 * @property {number} attempt_outbound_calls_position - The position of this column in the main table, if not presented = 0
 * @property {number} median_handling_tickets_duration_position - The position of this column in the main table, if not presented = 0
 * @property {number} chat_workload_position - chat_workload_position
 * @property {number} location_position - The position of this column in the main table, if not presented = 0
 * @property {number} completed_handling_tickets_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_handling_tickets_duration_position - total_handling_tickets_duration_position
 * @property {GUID} role_id - Answers Role ID
 * @property {number} call_workload_position - call_workload_position
 * @property {GUID} client_id - client_id
 * @property {boolean} is_queue - Does this filter applied or not
 * @property {GUID} user_id - uuid
 * @property {boolean} is_group - Does this filter applied or not
 * @property {number} avg_completed_call_duration_position - avg_completed_call_duration_position
 * @property {number} utilization_rate_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_filters_applied - total_filters_applied
 * @property {number} avg_handling_tickets_duration_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_calls_position - total_calls_position
 * @property {number} resolved_tickets_position - resolved_tickets_position
 * @property {number} sms_workload_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_completed_call_duration_position - The position of this column in the main table, if not presented = 0
 * @property {number} median_call_duration_position - median_call_duration_position
 * @property {number} total_columns_presented - Total number of presented columns in the main table
 * @property {number} groups_position - The position of this column in the main table, if not presented = 0
 * @property {number} email_workload_position - The position of this column in the main table, if not presented = 0
 * @property {number} qualified_channels_position - The position of this column in the main table, if not presented = 0
 * @property {boolean} is_location - Does this filter applied or not
 * @property {string} lang - lang
 * @property {number} channel_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_replies_position - The position of this column in the main table, if not presented = 0
 * @property {boolean} is_role - is_role
 * @return {LogObject<appControlRoomPageLoadSuccessParams>} LogObject<appControlRoomPageLoadSuccessParams>
 */
export function appControlRoomPageLoadSuccess(params) {
    return { evid: 2601, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'devGeneralAnswersFedEvent' event (evid: 42)
 *
 * Event description: This is a general event that serves as "event candidate". Relevant events will be later developed as standalone events.
 *
 * @param {devGeneralAnswersFedEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} module - module in the app (kb / ticketing / cc / chat / etc.)
 * @property {GUID} item_id - Item ID
 * @property {GUID} tenant_id - tenant ID
 * @property {string} feature - feature
 * @property {string} data - data
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} type - event description
 * @return {LogObject<devGeneralAnswersFedEventParams>} LogObject<devGeneralAnswersFedEventParams>
 */
export function devGeneralAnswersFedEvent(params) {
    return { evid: 42, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'clickOnStatusPageBanner' event (evid: 44)
 *
 * Event description: Click on "Status Page" Banner
 *
 * @param {clickOnStatusPageBannerParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - client_id
 * @property {string} incident_name - The title of the incident fetched from the status page
 * @property {GUID} user_id - uuid
 * @property {boolean} resolved - State of the Incident
 * @return {LogObject<clickOnStatusPageBannerParams>} LogObject<clickOnStatusPageBannerParams>
 */
export function clickOnStatusPageBanner(params) {
    return { evid: 44, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'statusPageBannerLoaded' event (evid: 45)
 *
 * Event description: Status Page Banner loaded
 *
 * @param {statusPageBannerLoadedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - client_id
 * @property {string} incident_name - The title of the incident fetched from the status page
 * @property {GUID} user_id - uuid
 * @property {boolean} resolved - State of the Incident
 * @return {LogObject<statusPageBannerLoadedParams>} LogObject<statusPageBannerLoadedParams>
 */
export function statusPageBannerLoaded(params) {
    return { evid: 45, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'statusPageReportedAProblem' event (evid: 46)
 *
 * Event description: User clicked on “I have a problem” button on the External Wix Status Page
 *
 * @param {statusPageReportedAProblemParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} description - description
 * @property {GUID} client_id - client_id
 * @property {string} service - Edit or Publish a site, Access site, Other
 * @property {GUID} user_id - uuid
 * @return {LogObject<statusPageReportedAProblemParams>} LogObject<statusPageReportedAProblemParams>
 */
export function statusPageReportedAProblem(params) {
    return { evid: 46, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appGeneralInAppNotificationsClientEngagement' event (evid: 4902)
 *
 * Event description: A generic event for the following clicks/engagements related to In-app notifications: (1) click on main notifications button to open the notification list, (2) click on notification (3) create announcement click,  (4) Send announcement click
 *
 * @param {appGeneralInAppNotificationsClientEngagementParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} engagement - What kind of engagement happened. Examples: (1) main notification button click (2) notification click (3) create announcement click (4) send announcement click
 * @property {string} data - Json of Data related to the engagement. Examples: (1) If the engagement is "notification click" data will include notification_id, notification_type, notification_content etc (2) If the engagement is "send announcement click" data will include announcement title, content, type, recipients etc
 * @property {GUID} role_id - Role ID of the engaging member
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the engaging member
 * @property {string} lang - Answers language according to the Account settings
 * @return {LogObject<appGeneralInAppNotificationsClientEngagementParams>} LogObject<appGeneralInAppNotificationsClientEngagementParams>
 */
export function appGeneralInAppNotificationsClientEngagement(params) {
    return { evid: 4902, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'agentDeclinesCall' event (evid: 4906)
 *
 * Event description: Triggers when an agent delines a call, returns Call Id and Tenant ID,
 * Agent ID as implicit UUID field.
 *
 * @param {agentDeclinesCallParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} callid - Call ID of the declined call
 * @return {LogObject<agentDeclinesCallParams>} LogObject<agentDeclinesCallParams>
 */
export function agentDeclinesCall(params) {
    return { evid: 4906, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreation' event (evid: 4907)
 *
 * Event description: Triggers whenever a new ticket is created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationParams} params - The parameters for this event
 * @property {GUID} ticket_id - The id of the ticket that was created using the widget
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The Wix uuid of the user the callback is created for
 * @property {GUID} queue_id - The guid of the queue in which the callback is created
 * @property {GUID} topic_id - The guid of the topic in which the callback is created
 * @property {GUID} assigned_group_id - The guid of the group the created ticket is assigned to at ticket creation
 * @property {GUID} source_ticket_id - The ticket guid from which the callback request is created, can be null
 * @property {GUID} line_id - The line ID we call the user from
 * @property {GUID} agent_id - The Answers UUID of the agent who created a ticket using the widget
 * @return {LogObject<callbackWidgetTicketCreationParams>} LogObject<callbackWidgetTicketCreationParams>
 */
export function callbackWidgetTicketCreation(params) {
    return { evid: 4907, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersBannerView' event (evid: 4908)
 *
 * Event description: Fired when the user enters a page that has a banner
 *
 * @param {answersBannerViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} banner_text - banner text
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} banner_name - banner_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} lang - Answers language
 * @property {string} banner_language - banner_language
 * @return {LogObject<answersBannerViewParams>} LogObject<answersBannerViewParams>
 */
export function answersBannerView(params) {
    return { evid: 4908, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersBannerClick' event (evid: 4909)
 *
 * Event description: Fired when a user clicks a banner in Answers
 *
 * @param {answersBannerClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} clicked_text - The text that was clicked on
 * @property {string} banner_text - banner text
 * @property {GUID} tenant_id - tenant_id
 * @property {string} banner_name - banner name
 * @property {GUID} client_id - client_id
 * @property {string} clicked_item_type - what was clicked on (link/close etc.)
 * @property {GUID} user_id - uuid
 * @property {string} lang - Answers language
 * @property {string} banner_language - banner language
 * @property {string} clicked_url - Destination url the link takes the user to
 * @return {LogObject<answersBannerClickParams>} LogObject<answersBannerClickParams>
 */
export function answersBannerClick(params) {
    return { evid: 4909, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'clickOnEscalateToVistaButton' event (evid: 4914)
 *
 * Event description: Button appears to experts only for Vista Users threads. The experts clicks on this button if he wants to request a callback from Vista CC to the user.
 *
 * @param {clickOnEscalateToVistaButtonParams} params - The parameters for this event
 * @property {GUID} ticket_id - The vista ticket
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} description - The issue description of the user
 * @property {boolean} is_action_successful - Did the action of the expert was approved
 * @property {GUID} uuid - uuid
 * @property {string} country - the vista user country
 * @property {GUID} client_id - the vista user
 * @property {GUID} user_id - uuid
 * @property {string} language - the vista user language
 * @property {GUID} agent_id - The expert that clicked on the button
 * @return {LogObject<clickOnEscalateToVistaButtonParams>} LogObject<clickOnEscalateToVistaButtonParams>
 */
export function clickOnEscalateToVistaButton(params) {
    return { evid: 4914, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'callTheAiSummary' event (evid: 4916)
 *
 * Event description: The event that marks when the summary was requested to be generated when Call the Ai summary
 *
 * @param {callTheAiSummaryParams} params - The parameters for this event
 * @property {GUID} ticket_id - the ticket ID
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - the tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - who is the expert that opened the Ai assistant
 * @property {GUID} agent_id - who is the expert that opened the Ai assistant
 * @return {LogObject<callTheAiSummaryParams>} LogObject<callTheAiSummaryParams>
 */
export function callTheAiSummary(params) {
    return { evid: 4916, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'aiSummaryAppearsInTheInternalNote' event (evid: 4917)
 *
 * Event description: It tracks the time between asking the AI for a summary and when it appears in the user's inbox.
 *
 * @param {aiSummaryAppearsInTheInternalNoteParams} params - The parameters for this event
 * @property {GUID} ticket_id - the ticket ID
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - the tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - who is the expert that opened the Ai assistant
 * @property {DateTime} request_time - The moment that the expert request from the AI the summary
 * @property {GUID} agent_id - who is the expert that opened the Ai assistant
 * @return {LogObject<aiSummaryAppearsInTheInternalNoteParams>} LogObject<aiSummaryAppearsInTheInternalNoteParams>
 */
export function aiSummaryAppearsInTheInternalNote(params) {
    return { evid: 4917, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'aiSummaryErrors' event (evid: 4918)
 *
 * Event description: There are a few possible reasons why the AI summary fails such as: API failed , Realtime Event Not Received, Saved Reply Not Found
 *
 * @param {aiSummaryErrorsParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - the tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - who is the expert that opened the Ai assistant
 * @property {string} error_type - API failed , Realtime Event Not Received, Saved Reply Not Found
 * @property {boolean} is_error - if TRUE there is an error
 * @property {GUID} agent_id - who is the expert that opened the Ai assistant
 * @return {LogObject<aiSummaryErrorsParams>} LogObject<aiSummaryErrorsParams>
 */
export function aiSummaryErrors(params) {
    return { evid: 4918, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'wrapUpSessionEndedAutomatically' event (evid: 4921)
 *
 * Event description: In the end of the wrap up by the timer, the session will be ended automatically, and this event will be sanded.
 *
 * @param {wrapUpSessionEndedAutomaticallyParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} agent_id - The expert handling the ticket.
 * @return {LogObject<wrapUpSessionEndedAutomaticallyParams>} LogObject<wrapUpSessionEndedAutomaticallyParams>
 */
export function wrapUpSessionEndedAutomatically(params) {
    return { evid: 4921, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'wrapUpIsTheExpertBackToTheTicket' event (evid: 4922)
 *
 * Event description: In the end of the wrap up by the timer, the session will be ended automatically, if the expert open back the same ticket this event will be sanded
 *
 * @param {wrapUpIsTheExpertBackToTheTicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} agent_id - The expert handling the ticket.
 * @return {LogObject<wrapUpIsTheExpertBackToTheTicketParams>} LogObject<wrapUpIsTheExpertBackToTheTicketParams>
 */
export function wrapUpIsTheExpertBackToTheTicket(params) {
    return { evid: 4922, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersSidePanelClickEvent' event (evid: 4923)
 *
 * Event description: triggers when a user (expert) clicks a tab or one of the elements within the tabs in the side bar
 *
 * @param {answersSidePanelClickEventParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} widget_id - in case of a widget, the id of the widget the user interacts with
 * @property {string} toolkit_element_mode - state of the toolkit- for example: regular/condensed mode for the header
 * @property {number} sub_element_order - order of the sub element clicked on
 * @property {string} tab_name - name of the tab clicked on/the user is on when clicking an element
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {string} sub_element - name of the sub element clicked on
 * @property {string} toolkit_element - the section in the toolkit the user is engaging with (header, tab, navbar)
 * @property {GUID} client_id - client_id
 * @property {string} element - name of the element clicked on
 * @property {number} element_order - order of the element clicked on
 * @property {string} version_name - to differentiate from which side panel the events are fired- old one or new (toolkit)
 * @property {string} sub_element_thread_id - id of the thread interacted with from the 'recent tickets' part
 * @property {string} action_type - type of the action performed by the user (click, scroll, etc.)
 * @property {GUID} agent_id - The expert handling the ticket
 * @property {string} product - tab section the user is on when performing the action
 * @property {string} tab_section - name of the section in the tab the click happned on
 * @property {string} value - The value that as chosen/ written.
 * @property {string} uuid - id of the user the ticket is assigned to
 * @return {LogObject<answersSidePanelClickEventParams>} LogObject<answersSidePanelClickEventParams>
 */
export function answersSidePanelClickEvent(params) {
    return { evid: 4923, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersSidePanelViewEvent' event (evid: 4924)
 *
 * Event description: Fires when a side bar tab is opened.
 *
 * @param {answersSidePanelViewEventParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tab_name - name of the tab clicked on/the user is on when clicking an element
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} previous_tab - the tab the user was on before arriving to the current tab
 * @property {string} open_method - how the user got to the tab- manual/auto
 * @property {GUID} agent_id - The expert handling the ticket.
 * @return {LogObject<answersSidePanelViewEventParams>} LogObject<answersSidePanelViewEventParams>
 */
export function answersSidePanelViewEvent(params) {
    return { evid: 4924, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'channelAvailabilityTransfers' event (evid: 4925)
 *
 * Event description: before offering the expert to make the transfer and the relevant transfer type,  the API checks if there are experts not offline, and the queue in business hours
 *
 * @param {channelAvailabilityTransfersParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group of the ticket
 * @property {string} channel - channel of the ticket
 * @property {string} transferred_topic_id - the topic id that the ticket is transferred to
 * @property {GUID} transferred_group_id - the group id that the ticket is transferred to
 * @property {GUID} client_id - client_id
 * @property {string} reason - why the channel is not available
 * @property {GUID} user_id - user
 * @property {string} currentCallId - from call id of the ticket
 * @property {GUID} topic_id - topic of the ticket
 * @property {string} request_id - request_id of the API
 * @property {boolean} channel_availability - is the channel available or not
 * @property {string} lastInteractionId - Interaction id of the chat
 * @return {LogObject<channelAvailabilityTransfersParams>} LogObject<channelAvailabilityTransfersParams>
 */
export function channelAvailabilityTransfers(params) {
    return { evid: 4925, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersCallsEvent' event (evid: 4926)
 *
 * Event description: Fires when elements are presented/clicked in the UI during a call in Answers
 *
 * @param {answersCallsEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} element_name - name of the element presented/interacted with
 * @property {string} elementText - Additional details about the element presented/interacted with
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} interaction_id - id of the interaction the expert is currently on for the call
 * @property {string} interacted_element - specifying the exact element (e.g. button, CTA name, etc) the user interacted with
 * @property {string} value - additional detailed for the interaction
 * @property {string} action_type - type of action taken by the user- click, type, etc.
 * @property {GUID} agent_id - The user triggering the event
 * @return {LogObject<answersCallsEventParams>} LogObject<answersCallsEventParams>
 */
export function answersCallsEvent(params) {
    return { evid: 4926, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersPageEngegement' event (evid: 4927)
 *
 * Event description: Fired every 10 seconds and indicates if within that timeframe the user performed one of the following actions: scroll, mouse move, click.
 *
 * @param {answersPageEngegementParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} reply_area - reply area the expert was engaged with (engaged=wrote): pubic/internal/both
 * @property {string} replay_area - replay area the expert was engaged with (engaged=wrote): pubic/internal/both
 * @property {string} tab_name - last tab that was opened in the ping time frame
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - width of the screen used by the user
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} page_name - last answers page user was on in the ping time frame
 * @property {number} window_width - width of the window (tab) used by the user to view Answers
 * @property {string} action_type - indicates the type of activity done by the user on the page
 * @property {GUID} agent_id - The expert handling the ticket
 * @return {LogObject<answersPageEngegementParams>} LogObject<answersPageEngegementParams>
 */
export function answersPageEngegement(params) {
    return { evid: 4927, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersCallFlowUiEvents' event (evid: 4928)
 *
 * Event description: triggers when a user interacts with call elements in Answers
 *
 * @param {answersCallFlowUiEventsParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {number} call_process_time - seconds counter of the call at event time
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {string} sub_element - name of the sub element clicked on/viewed
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} element - name of the element clicked on/viewed
 * @property {string} instance_id - id of the interaction the expert is currently on for the call
 * @property {string} value - action value
 * @property {string} action_type - type of the action performed by the user (click, scroll, etc.)
 * @property {GUID} agent_id - The expert handling the ticket
 * @return {LogObject<answersCallFlowUiEventsParams>} LogObject<answersCallFlowUiEventsParams>
 */
export function answersCallFlowUiEvents(params) {
    return { evid: 4928, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersChatFlowUiEvents' event (evid: 4929)
 *
 * Event description: triggers when a user interacts with Chat elements in Answers
 *
 * @param {answersChatFlowUiEventsParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} sub_element - name of the sub element clicked on/viewed
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} interaction_id - id of the interaction the expert is currently on for the call
 * @property {string} element - name of the element clicked on/viewed
 * @property {number} chat_process_time - seconds counter of the call at event time
 * @property {string} value - action value
 * @property {string} action_type - type of the action performed by the user (click, scroll, etc.)
 * @property {GUID} agent_id - The expert handling the ticket
 * @return {LogObject<answersChatFlowUiEventsParams>} LogObject<answersChatFlowUiEventsParams>
 */
export function answersChatFlowUiEvents(params) {
    return { evid: 4929, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'answersWrapUpFlowUiEvents' event (evid: 4930)
 *
 * Event description: triggers when a user interacts with wrap up elements in Answers
 *
 * @param {answersWrapUpFlowUiEventsParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} type_of_interaction - The type of interaction chat/call
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} sub_element - name of the sub element clicked on/viewed
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {GUID} interaction_id - id of the interaction the expert is currently on for the call
 * @property {string} element - name of the element clicked on/viewed
 * @property {number} processing_time - seconds counter of the call/chat at event time
 * @property {string} value - action value
 * @property {string} action_type - type of the action performed by the user (click, scroll, etc.)
 * @property {GUID} agent_id - The expert handling the ticket
 * @return {LogObject<answersWrapUpFlowUiEventsParams>} LogObject<answersWrapUpFlowUiEventsParams>
 */
export function answersWrapUpFlowUiEvents(params) {
    return { evid: 4930, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'devBindingAnswersAndWixIdentifiers' event (evid: 50)
 *
 * Event description: Event is fired every time that: 1. A user loads the Answers Marketing site or the Answers App  2. A wixCIDX and/or wixUIDX cookie was detected
 *
 * @param {devBindingAnswersAndWixIdentifiersParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - Answers Client (Anonymous) ID
 * @property {GUID} wix_user_id - Wix User ID
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} wix_client_id - Wix Client (Anonymous) ID
 * @return {LogObject<devBindingAnswersAndWixIdentifiersParams>} LogObject<devBindingAnswersAndWixIdentifiersParams>
 */
export function devBindingAnswersAndWixIdentifiers(params) {
    return { evid: 50, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appOnboardingGeneralOnboardingEvent' event (evid: 901)
 *
 * Event description: This is a general onboarding event. At first phase of the Onboarding dev process, this event will be used for reporting all actions in the "Guide" screen
 *
 * @param {appOnboardingGeneralOnboardingEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers Account ID
 * @property {string} params - Parameters
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} type - Type of event
 * @return {LogObject<appOnboardingGeneralOnboardingEventParams>} LogObject<appOnboardingGeneralOnboardingEventParams>
 */
export function appOnboardingGeneralOnboardingEvent(params) {
    return { evid: 901, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'appOnboardingGeneralQuestionsEvent' event (evid: 902)
 *
 * Event description: This is a general onboarding event. At first phase of the Onboarding dev process, this event will be used for reporting all actions in the "Questions" screen
 *
 * @param {appOnboardingGeneralQuestionsEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers Account ID
 * @property {string} params - Parameters
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} type - Type of event
 * @return {LogObject<appOnboardingGeneralQuestionsEventParams>} LogObject<appOnboardingGeneralQuestionsEventParams>
 */
export function appOnboardingGeneralQuestionsEvent(params) {
    return { evid: 902, src: 77, endpoint: 'wix-answers', params: params };
}
/**
 * A function to create a log object for the 'devGeneralTwilioEvent' event (evid: 99)
 *
 * Event description: This is a general event for data we get from Twilio. We use for QA and debug.
 *
 * @param {devGeneralTwilioEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} item_id - Item ID
 * @property {GUID} tenant_id - tenant ID
 * @property {string} data - data
 * @property {string} tab_id - persistent id for the open tab, to debug multiple tab issues
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} type - type
 * @return {LogObject<devGeneralTwilioEventParams>} LogObject<devGeneralTwilioEventParams>
 */
export function devGeneralTwilioEvent(params) {
    return { evid: 99, src: 77, endpoint: 'wix-answers', params: params };
}
//# sourceMappingURL=index.js.map